const Poems1 = {

    "古詩": [
        {
            "key": 1,
            "曲目": "一",
            "詩名": "行行重行行",
            "作者": "",
            "內容": [
                "行行重行行，與君生別離。",
                "相去萬餘里，各在天一涯。",
                "道路阻且長，會面安可知。",
                "胡馬依北風，越鳥巢南枝。",
                "相去日已遠，衣帶日已緩。",
                "浮雲蔽白日，遊子不顧返。",
                "思君令人老，歲月忽已晚。",
                "棄捐勿復道，努力加餐飯。"
            ],
            "下載": []
        },
        {
            "key": 2,
            "曲目": "二",
            "詩名": "迢迢牽牛星",
            "作者": "",
            "內容": [
                "迢迢牽牛星，",
                "皎皎河漢女。",
                "纖纖擢素手，",
                "札札弄機杼。",
                "終日不成章，",
                "泣涕零如雨。",
                "河漢清且淺，",
                "相去復幾許。",
                "盈盈一水間，",
                "脈脈不得語。"
            ],
            "下載": []
        },
        {
            "key": 3,
            "曲目": "三",
            "詩名": "短歌行",
            "作者": "曹操",
            "內容": [
                "對酒當歌，人生幾何？",
                "譬如朝露，去日苦多。",
                "慨當以慷，憂思難忘。",
                "何以解憂？唯有杜康。",
                "青青子衿，悠悠我心。",
                "但為君故，沉吟至今。",
                "呦呦鹿鳴，食野之苹。",
                "我有嘉賓，鼓瑟吹笙。",
                "明明如月，何時可掇？",
                "憂從中來，不可斷絕。",
                "越陌度阡，枉用相存。",
                "契闊談讌，心念舊恩。",
                "月明星稀，烏鵲南飛。",
                "繞樹三匝，何枝可依？",
                "山不厭高，海不厭深。",
                "周公吐哺，天下歸心。"
            ],
            "下載": []
        },
        {
            "key": 4,
            "曲目": "四",
            "詩名": "七步詩",
            "作者": "曹植",
            "內容": [
                "煮豆燃豆萁，",
                "豆在釜中泣。",
                "本是同根生，",
                "相煎何太急？"
            ],
            "下載": []
        },
        {
            "key": 5,
            "曲目": "五",
            "詩名": "飲酒 其五",
            "作者": "陶淵明",
            "內容": [
                "結廬在人境，而無車馬喧。",
                "問君何能爾？心遠地自偏。",
                "採菊東籬下，悠然見南山。",
                "山氣日夕佳，飛鳥相與還。",
                "此中有真意，欲辯已忘言。"
            ],
            "下載": []
        },
        {
            "key": 6,
            "曲目": "六",
            "詩名": "春江花月夜",
            "作者": "張若虛",
            "內容": [
                "春江潮水連海平，",
                "海上明月共潮生。",
                "灎灎隨波千萬里，",
                "何處春江無月明。",
                "江流宛轉繞芳甸，",
                "月照花林皆似霰。",
                "空裏流霜不覺飛，",
                "汀上白沙看不見。",
                "江天一色無纖塵，",
                "皎皎空中孤月輪。",
                "江畔何人初見月？",
                "江月何年初照人？",
                "人生代代無窮已，",
                "江月年年望相似。",
                "不知江月待何人，",
                "但見長江送流水。",
                "白雲一片去悠悠，",
                "青楓浦上不勝愁。",
                "誰家今夜扁舟子？",
                "何處相思明月樓？",
                "可憐樓上月徘徊，",
                "應照離人妝鏡臺。",
                "玉戶簾中卷不去，",
                "搗衣砧上拂還來。",
                "此時相望不相聞，",
                "願逐月華流照君。",
                "鴻雁長飛光不度，",
                "魚龍潛躍水成文。",
                "昨夜閒潭夢落花，",
                "可憐春半不還家。",
                "江水流春去欲盡，",
                "江潭落月復西斜。",
                "斜月沉沉藏海霧，",
                "碣石瀟湘無限路。",
                "不知乘月幾人歸，",
                "落月搖情滿江樹。"
            ],
            "下載": []
        },
        {
            "key": 7,
            "曲目": "七",
            "詩名": "登幽州臺歌",
            "作者": "陳子昂",
            "內容": [
                "前不見古人，",
                "後不見來者。",
                "念天地之悠悠，",
                "獨愴然而涕下。"
            ],
            "下載": []
        },
        {
            "key": 8,
            "曲目": "八",
            "詩名": "送別",
            "作者": "王維",
            "內容": [
                "下馬飲君酒，問君何所之？",
                "君言不得意，歸臥南山陲。",
                "但去莫復問，白雲無盡時？"
            ],
            "下載": []
        },
        {
            "key": 9,
            "曲目": "九",
            "詩名": "下終南山過斛斯山人宿置酒",
            "作者": "李白",
            "內容": [
                "暮從碧山下，山月隨人歸。",
                "卻顧所來徑，蒼蒼橫翠微。",
                "相攜及田家，童稚開荊扉。",
                "綠竹入幽徑，青蘿拂行衣。",
                "歡言得所憩，美酒聊共揮。",
                "長歌吟松風，曲盡河星稀。",
                "我醉君復樂，陶然共忘機。"
            ],
            "下載": []
        },
        {
            "key": 10,
            "曲目": "十",
            "詩名": "宣州謝眺樓餞別校書叔雲",
            "作者": "李白",
            "內容": [
                "棄我去者，昨日之日不可留。",
                "亂我心者，今日之日多煩憂。",
                "長風萬里送秋雁，",
                "對此可以酣高樓。",
                "蓬萊文章建安骨，",
                "中間小謝又清發。",
                "俱懷逸興壯思飛，",
                "欲上青天覽明月。",
                "抽刀斷水水更流，",
                "舉杯消愁愁更愁。",
                "人生在世不稱意，",
                "明朝散髮弄扁舟。"
            ],
            "下載": []
        },
        {
            "key": 11,
            "曲目": "十一",
            "詩名": "長干行",
            "作者": "李白",
            "內容": [
                "妾髮初覆額，折花門前劇；",
                "郎騎竹馬來，遶床弄青梅。",
                "同居長干里，兩小無嫌猜，",
                "十四為君婦，羞顏未嘗開。",
                "低頭向暗壁，千喚不一回。",
                "十五始展眉，願同塵與灰。",
                "常存抱柱信，豈上望夫臺。",
                "十六君遠行，瞿塘灩澦堆。",
                "五月不可觸，猿聲天上哀。",
                "門前遲行跡，一一生綠苔。",
                "苔深不能掃，落葉秋風早。",
                "八月蝴蝶來，雙飛西園草。",
                "感此傷妾心，坐愁紅顏老。",
                "早晚下三巴，預將書報家。",
                "相迎不道遠，直至長風沙。"
            ],
            "下載": []
        },
        {
            "key": 12,
            "曲目": "十二",
            "詩名": "將進酒",
            "作者": "李白",
            "內容": [
                "君不見，黃河之水天上來，",
                "奔流到海不復回。",
                "君不見，高堂明鏡悲白髮，",
                "朝如青絲暮成雪。",
                "人生得意須盡歡，",
                "莫使金樽空對月。",
                "天生我材必有用，",
                "千金散盡還復來。",
                "烹羊宰牛且為樂，",
                "會須一飲三百杯。",
                "岑夫子，丹丘生，",
                "將進酒，杯莫停。",
                "與君歌一曲，",
                "請君為我傾耳聽。",
                "鐘鼓饌玉不足貴，",
                "但願長醉不復醒。",
                "古來聖賢皆寂寞，",
                "惟有飲者留其名。",
                "陳王昔時宴平樂，",
                "斗酒十千恣歡謔。",
                "主人何為言少錢，",
                "徑須沽取對君酌。",
                "五花馬，千金裘，",
                "呼兒將出換美酒，",
                "與爾同銷萬古愁。"
            ],
            "下載": []
        },
        {
            "key": 13,
            "曲目": "十三",
            "詩名": "贈衛八處士",
            "作者": "杜甫",
            "內容": [
                "人生不相見，動如參與商。",
                "今夕復何夕，共此燈燭光。",
                "少壯能幾時，鬢髮各已蒼。",
                "訪舊半為鬼，驚呼熱中腸。",
                "焉知二十載，重上君子堂。",
                "昔別君未婚，兒女忽成行。",
                "怡然敬父執，問我來何方？",
                "問答乃未已，驅兒羅酒漿。",
                "夜雨剪春韭，新炊間黃粱。",
                "主稱會面難，一舉累十觴。",
                "十觴亦不醉，感子故意長。",
                "明日隔山岳，世事兩茫茫。"
            ],
            "下載": []
        },
        {
            "key": 14,
            "曲目": "十四",
            "詩名": "於潛僧綠筠軒",
            "作者": "蘇軾",
            "內容": [
                "可使食無肉，",
                "不可使居無竹。",
                "無肉令人瘦，",
                "無竹令人俗。",
                "人瘦尚可肥，",
                "俗士不可醫。",
                "旁人笑此言，",
                "似高還似癡。",
                "若對此君仍大嚼，",
                "世間那有揚州鶴!"
            ],
            "下載": []
        }
    ],
    "五言絕句": [
        {
            "key": 1,
            "曲目": "一",
            "詩名": "登鸛鵲樓",
            "作者": "王之渙",
            "內容": [
                "白日依山盡，",
                "黃河入海流。",
                "欲窮千里目，",
                "更上一層樓。"
            ],
            "下載": []
        },
        {
            "key": 2,
            "曲目": "二",
            "詩名": "春曉",
            "作者": "孟浩然",
            "內容": [
                "春眠不覺曉，",
                "處處聞啼鳥。",
                "夜來風雨聲，",
                "花落知多少?"
            ],
            "下載": []
        },
        {
            "key": 3,
            "曲目": "三",
            "詩名": "宿建德江",
            "作者": "孟浩然",
            "內容": [
                "移舟泊煙渚，",
                "日暮客愁新。",
                "野曠天低樹，",
                "江清月近人。"
            ],
            "下載": []
        },
        {
            "key": 4,
            "曲目": "四",
            "詩名": "雜詩",
            "作者": "王維",
            "內容": [
                "君自故鄉來，",
                "應知故鄉事。",
                "來日綺窗前，",
                "寒梅著花未？"
            ],
            "下載": []
        },
        {
            "key": 5,
            "曲目": "五",
            "詩名": "獨坐敬亭山",
            "作者": "李白",
            "內容": [
                "眾鳥高飛盡，",
                "孤雲獨去閒。",
                "相看兩不厭，",
                "只有敬亭山。"
            ],
            "下載": []
        },
        {
            "key": 6,
            "曲目": "六",
            "詩名": "秋夜寄邱員外",
            "作者": "韋應物",
            "內容": [
                "懷君屬秋夜，",
                "散步詠涼天。",
                "空山松子落，",
                "幽人應未眠。"
            ],
            "下載": []
        },
        {
            "key": 7,
            "曲目": "七",
            "詩名": "憫農詩",
            "作者": "李紳",
            "內容": [
                "鋤禾日當午，",
                "汗滴禾下土。",
                "誰知盤中飧，",
                "粒粒皆辛苦。"
            ],
            "下載": []
        },
        {
            "key": 8,
            "曲目": "八",
            "詩名": "江雪",
            "作者": "柳宗元",
            "內容": [
                "千山鳥飛絕，",
                "萬徑人蹤滅。",
                "孤舟蓑笠翁，",
                "獨釣寒江雪。"
            ],
            "下載": []
        },
        {
            "key": 9,
            "曲目": "九",
            "詩名": "尋隱者不遇",
            "作者": "賈島",
            "內容": [
                "松下問童子，",
                "言師採藥去。",
                "只在此山中，",
                "雲深不知處。"
            ],
            "下載": []
        },
        {
            "key": 10,
            "曲目": "十",
            "詩名": "登樂遊原",
            "作者": "李商隱",
            "內容": [
                "向晚意不適，",
                "驅車登古原。",
                "夕陽無限好，",
                "只是近黃昏。"
            ],
            "下載": []
        },
        {
            "key": 11,
            "曲目": "十一",
            "詩名": "夏日絕句",
            "作者": "李清照",
            "內容": [
                "生當作人傑，",
                "死亦為鬼雄。",
                "至今思項羽，",
                "不肯過江東。"
            ],
            "下載": []
        },
    ],
    "七言絕句": [
        {
            "key": 1,
            "曲目": "一",
            "詩名": "九月九日憶山東兄弟",
            "作者": "王維",
            "內容": [
                "獨在異鄉為異客，",
                "每逢佳節倍思親。",
                "遙知兄弟登高處，",
                "遍插茱萸少一人。"
            ],
            "下載": []
        },
        {
            "key": 2,
            "曲目": "二",
            "詩名": "送元二使安西",
            "作者": "王維",
            "內容": [
                "渭城朝雨浥輕塵，",
                "客舍青青柳色新。",
                "勸君更盡一杯酒，",
                "西出陽關無故人。"
            ],
            "下載": []
        },
        {
            "key": 3,
            "曲目": "三",
            "詩名": "芙蓉樓送辛漸",
            "作者": "王昌齡",
            "內容": [
                "寒雨連江夜入吳，",
                "平明送客楚山孤。",
                "洛陽親友如相問，",
                "一片冰心在玉壺。"
            ],
            "下載": []
        },
        {
            "key": 4,
            "曲目": "四",
            "詩名": "出塞",
            "作者": "王昌齡",
            "內容": [
                "秦時明月漢時關，",
                "萬里長征人未還。",
                "但使龍城飛將在，",
                "不叫胡馬度陰山。"
            ],
            "下載": []
        },
        {
            "key": 5,
            "曲目": "五",
            "詩名": "下江陵",
            "作者": "李白",
            "內容": [
                "朝辭白帝彩雲間，",
                "千里江陵一日還。",
                "兩岸猿聲啼不住，",
                "輕舟已過萬重山。"
            ],
            "下載": []
        },
        {
            "key": 6,
            "曲目": "六",
            "詩名": "寒食",
            "作者": "韓翃",
            "內容": [
                "春城無處不飛花，",
                "寒食東風御柳斜。",
                "日暮漢宮傳蠟燭，",
                "輕煙散入五侯家。"
            ],
            "下載": []
        },
        {
            "key": 7,
            "曲目": "七",
            "詩名": "滁州西澗",
            "作者": "韋應物",
            "內容": [
                "獨憐幽草澗邊生，",
                "上有黃鸝深樹鳴。",
                "春潮帶雨晚來急，",
                "野渡無人舟自橫。"
            ],
            "下載": []
        },
        {
            "key": 8,
            "曲目": "八",
            "詩名": "楓橋夜泊",
            "作者": "張繼",
            "內容": [
                "月落烏啼霜滿天，",
                "江楓漁火對愁眠。",
                "姑蘇城外寒山寺，",
                "夜半鐘聲到客船。"
            ],
            "下載": []
        },
        {
            "key": 9,
            "曲目": "九",
            "詩名": "題都城南莊",
            "作者": "崔護",
            "內容": [
                "去年今日此門中，",
                "人面桃花相映紅。",
                "人面不知何處去，",
                "桃花依舊笑春風。"
            ],
            "下載": []
        },
        {
            "key": 10,
            "曲目": "十",
            "詩名": "金縷衣",
            "作者": "杜秋娘",
            "內容": [
                "勸君莫惜金縷衣，",
                "勸君惜取少年時。",
                "花開堪折直須折，",
                "莫待無花空折枝。"
            ],
            "下載": []
        },
        {
            "key": 11,
            "曲目": "十一",
            "詩名": "清明",
            "作者": "杜牧",
            "內容": [
                "清明時節雨紛紛，",
                "路上行人欲斷魂。",
                "借問酒家何處有？",
                "牧童遙指杏花村。"
            ],
            "下載": []
        },
        {
            "key": 12,
            "曲目": "十二",
            "詩名": "贈別二首之二",
            "作者": "杜牧",
            "內容": [
                "多情卻似總無情，",
                "唯覺樽前笑不成。",
                "蠟燭有心還惜別，",
                "替人垂淚到天明。"
            ],
            "下載": []
        },
        {
            "key": 13,
            "曲目": "十三",
            "詩名": "題烏江亭",
            "作者": "杜牧",
            "內容": [
                "勝敗兵家事不期，",
                "包羞忍恥是男兒。",
                "江東子弟多才俊，",
                "卷土重來未可知！"
            ],
            "下載": []
        },
        {
            "key": 14,
            "曲目": "十四",
            "詩名": "夜雨寄北",
            "作者": "李商隱",
            "內容": [
                "君問歸期未有期，",
                "巴山夜雨漲秋池。",
                "何當共剪西窗燭，",
                "卻話巴山夜雨時。"
            ],
            "下載": []
        },
        {
            "key": 15,
            "曲目": "十五",
            "詩名": "畫眉鳥",
            "作者": "歐陽脩",
            "內容": [
                "百囀千聲隨意移，",
                "山花紅紫樹高低。",
                "始知鎖向金籠聽，",
                "不及林間自在啼。"
            ],
            "下載": []
        },
        {
            "key": 16,
            "曲目": "十六",
            "詩名": "泊船瓜州",
            "作者": "王安石",
            "內容": [
                "京口瓜洲一水間，",
                "鍾山只隔數重山。",
                "春風又綠江南岸，",
                "明月何時照我還？"
            ],
            "下載": []
        },
        {
            "key": 17,
            "曲目": "十七",
            "詩名": "頌",
            "作者": "無門和尚",
            "內容": [
                "春有百花秋有月，",
                "夏有涼風冬有雪。",
                "若無閒事掛心頭，",
                "便是人間好時節。"
            ],
            "下載": []
        },
    ],
    "五言律詩": [
        {
            "key": 1,
            "曲目": "一",
            "詩名": "送杜少府之任蜀川",
            "作者": "王勃",
            "內容": [
                "城闕輔三秦，風煙望五津。",
                "與君離別意，同是宦遊人。",
                "海內存知己，天涯若比鄰。",
                "無為在歧路，兒女共沾巾。"
            ],
            "下載": []
        },
        {
            "key": 2,
            "曲目": "二",
            "詩名": "山居秋瞑",
            "作者": "王維",
            "內容": [
                "空山新雨後，天氣晚來秋。",
                "明月松間照，清泉石上流。",
                "竹喧歸浣女，蓮動下漁舟。",
                "隨意春芳歇，王孫自可留。"
            ],
            "下載": []
        },
        {
            "key": 3,
            "曲目": "三",
            "詩名": "終南別業",
            "作者": "王維",
            "內容": [
                "中歲頗好道，晚家南山陲。",
                "興來每獨往，勝事空自知。",
                "行到水窮處，坐看雲起時。",
                "偶然值林叟，談笑無還期。 "
            ],
            "下載": []
        },
        {
            "key": 4,
            "曲目": "四",
            "詩名": "酬張少府",
            "作者": "王維",
            "內容": [
                "晚年惟好靜，萬事不關心。",
                "自顧無長策，空知返舊林。",
                "松風吹解帶，山月照彈琴。",
                "君問窮通理，漁歌入浦深。"
            ],
            "下載": []
        },
        {
            "key": 5,
            "曲目": "五",
            "詩名": "望洞庭湖贈張丞相",
            "作者": "孟浩然",
            "內容": [
                "八月湖水平，涵虛混太清。",
                "氣蒸雲夢澤，波撼岳陽城。",
                "欲濟無舟楫，端居恥聖明。",
                "坐觀垂釣者，空有羨魚情。"
            ],
            "下載": []
        },
        {
            "key": 6,
            "曲目": "六",
            "詩名": "送友人",
            "作者": "李白",
            "內容": [
                "青山橫北郭，白水繞東城。",
                "此地一為別，孤蓬萬里征。",
                "浮雲遊子意，落日故人情。",
                "揮手自茲去，蕭蕭班馬鳴。"
            ],
            "下載": []
        },
        {
            "key": 7,
            "曲目": "七",
            "詩名": "題破山寺後禪院",
            "作者": "常建",
            "內容": [
                "清晨入古寺，初日照高林。",
                "曲徑通幽處，禪房花木深。",
                "山光悅鳥性，潭影空人心。",
                "萬籟此俱寂，惟餘鐘磬音。"
            ],
            "下載": []
        },
        {
            "key": 8,
            "曲目": "八",
            "詩名": "旅夜書懷",
            "作者": "杜甫",
            "內容": [
                "細草微風岸，危檣獨夜舟。",
                "星垂平野闊，月湧大江流。",
                "名豈文章著，官應老病休。",
                "飄飄何所似？天地一沙鷗。"
            ],
            "下載": []
        },
        {
            "key": 9,
            "曲目": "九",
            "詩名": "賦得古原草送別",
            "作者": "白居易",
            "內容": [
                "離離原上草，一歲一枯榮。",
                "野火燒不盡，春風吹又生。",
                "遠芳侵古道，晴翠接荒城。",
                "又送王孫去，萋萋滿別情。"
            ],
            "下載": []
        },
    ],
    "七言律詩": [
        {
            "key": 1,
            "曲目": "一",
            "詩名": "登金陵鳳凰臺",
            "作者": "李白",
            "內容": [
                "鳳凰臺上鳳凰遊，",
                "鳳去臺空江自流。",
                "吳宮花草埋幽徑，",
                "晉代衣冠成古丘。",
                "三山半落青天外，",
                "二水中分白鷺洲。",
                "總為浮雲能蔽日，",
                "長安不見使人愁。"
            ],
            "下載": []
        },
        {
            "key": 2,
            "曲目": "二",
            "詩名": "黃鶴樓",
            "作者": "崔顥",
            "內容": [
                "昔人已乘黃鶴去，",
                "此地空餘黃鶴樓。",
                "黃鶴一去不復返，",
                "白雲千載空悠悠。",
                "晴川歷歷漢陽樹， ",
                "芳草萋萋鸚鵡洲。",
                "日暮鄉關何處是，",
                "煙波江上使人愁。"
            ],
            "下載": []
        },
        {
            "key": 3,
            "曲目": "三",
            "詩名": "聞官軍收河南河北",
            "作者": "杜甫",
            "內容": [
                "劍外忽傳收薊北，",
                "初聞涕淚滿衣裳。",
                "卻看妻子愁何在，",
                "漫卷詩書喜欲狂。",
                "白日放歌須縱酒，",
                "青春作伴好還鄉。",
                "即從巴峽穿巫峽，",
                "便下襄陽向洛陽。 "
            ],
            "下載": []
        },
        {
            "key": 4,
            "曲目": "四",
            "詩名": "蜀相",
            "作者": "杜甫",
            "內容": [
                "丞相祠堂何處尋，",
                "錦官城外柏森森。",
                "映階碧草自春色，",
                "隔葉黃鸝空好音。",
                "三顧頻煩天下計，",
                "兩朝開濟老臣心。",
                "出師未捷身先死，",
                "長使英雄淚滿襟。"
            ],
            "下載": []
        },
        {
            "key": 5,
            "曲目": "五",
            "詩名": "登柳州城樓寄漳汀封連四州刺史",
            "作者": "柳宗元",
            "內容": [
                "城上高樓接大荒，",
                "海天愁思正茫茫。",
                "驚風亂颭芙蓉水，",
                "密雨斜侵薜荔牆。",
                "嶺樹重遮千里目，",
                "江流曲似九迴腸。",
                "共來百越文身地，",
                "猶自音書滯一鄉。"
            ],
            "下載": []
        },
        {
            "key": 6,
            "曲目": "六",
            "詩名": "無題",
            "作者": "李商隱",
            "內容": [
                "相見時難別亦難，",
                "東風無力百花殘。",
                "春蠶到死絲方盡，",
                "蠟炬成灰淚始乾。",
                "曉鏡但愁雲鬢改，",
                "夜吟應覺月光寒。",
                "蓬萊此去無多路，",
                "青鳥殷勤爲探看。"
            ],
            "下載": []
        },
        {
            "key": 7,
            "曲目": "七",
            "詩名": "和子由澠池懷舊",
            "作者": "蘇軾",
            "內容": [
                "人生到處知何似？",
                "應似飛鴻踏雪泥。",
                "泥上偶然留指爪，",
                "鴻飛那復計東西。",
                "老僧已死成新塔，",
                "壞壁無由見舊題。",
                "往日崎嶇還記否？",
                "路長人困蹇驢嘶。"
            ],
            "下載": []
        },
        {
            "key": 8,
            "曲目": "八",
            "詩名": "過零丁洋",
            "作者": "文天祥",
            "內容": [
                "辛苦遭逢起一經，",
                "干戈寥落四周星。",
                "山河破碎風飄絮，",
                "身世浮沉雨打萍。",
                "惶恐灘頭說惶恐，",
                "零丁洋裡嘆零丁。",
                "人生自古誰無死？",
                "留取丹心照汗青。"
            ],
            "下載": []
        },
    ],
    "詞": [
        {
            "key": 1,
            "曲目": "一",
            "詩名": "憶秦娥",
            "作者": "李白",
            "內容": [
                "簫聲咽，秦娥夢斷秦樓月。秦樓月，年年柳色，灞陵傷別。",
                "樂遊原上清秋節，咸陽古道音塵絕。音塵絕，西風殘照，漢家陵闕。"
            ],
            "下載": []
        },
        {
            "key": 2,
            "曲目": "二",
            "詩名": "鵲踏枝",
            "作者": "馮延巳",
            "內容": [
                "誰道閒情拋擲久？每到春來，惆悵還依舊。日日花前常病酒，不辭鏡裡朱顏瘦。",
                "河畔青蕪堤上柳，為問新愁，何事年年有？獨立小橋風滿袖，平林新月人歸後。"
            ],
            "下載": []
        },
        {
            "key": 3,
            "曲目": "三",
            "詩名": "花非花",
            "作者": "白居易",
            "內容": [
                "花非花，霧非霧。夜半來，天明去。來如春夢不多時，去似朝雲無覓處。"
            ],
            "下載": []
        },
        {
            "key": 4,
            "曲目": "四",
            "詩名": "相見歡",
            "作者": "李煜",
            "內容": [
                "無言獨上西樓，月如鉤。寂寞梧桐深院鎖清秋。",
                "剪不斷，理還亂，是離愁。別是一般滋味在心頭。"
            ],
            "下載": []
        },
        {
            "key": 5,
            "曲目": "五",
            "詩名": "虞美人",
            "作者": "李煜",
            "內容": [
                "春花秋月何時了？往事知多少？小樓昨夜又東風，故國不堪回首月明中。",
                "雕欄玉砌應猶在，只是朱顏改。問君能有幾多愁？恰似一江春水向東流。"
            ],
            "下載": []
        },
        {
            "key": 6,
            "曲目": "六",
            "詩名": "蝶戀花",
            "作者": "柳永",
            "內容": [
                "佇倚危樓風細細。望極春愁，黯黯生天際。草色煙光殘照裏，無言誰會憑闌意？",
                "擬把疏狂圖一醉。對酒當歌，強樂還無味。衣帶漸寬終不悔，為伊消得人憔悴。"
            ],
            "下載": []
        },
        {
            "key": 7,
            "曲目": "七",
            "詩名": "蘇幕遮",
            "作者": "范仲淹",
            "內容": [
                "碧雲天，黃葉地。秋色連波，波上寒煙翠。山映斜陽天接水。芳草無情，更在斜陽外。",
                "黯鄉魂，追旅思。夜夜除非，好夢留人睡。明月樓高休獨倚。酒入愁腸，化作相思淚。"
            ],
            "下載": []
        },
        {
            "key": 8,
            "曲目": "八",
            "詩名": "浣溪沙",
            "作者": "晏殊",
            "內容": [
                "一曲新詞酒一杯，去年天氣舊亭臺。夕陽西下幾時回？",
                "無可奈何花落去，似曾相識燕歸來。小園香徑獨徘徊。"
            ],
            "下載": []
        },
        {
            "key": 9,
            "曲目": "九",
            "詩名": "玉樓春",
            "作者": "宋祁",
            "內容": [
                "東城漸覺風光好，縠皺波紋迎客棹，綠楊煙外曉寒輕，紅杏枝頭春意鬧。",
                "浮生長恨歡娛少。肯愛千金輕一笑？為君持酒勸斜陽，且向花間留晚照。"
            ],
            "下載": []
        },
        {
            "key": 10,
            "曲目": "十",
            "詩名": "江城子",
            "作者": "蘇軾",
            "內容": [
                "十年生死兩茫茫，不思量，自難忘。千里孤墳，無處話淒涼。縱使相逢應不識，塵滿面，鬢如霜。",
                "夜來幽夢忽還鄉，小軒窗，正梳妝。相顧無言，唯有淚千行。料得年年腸斷處，明月夜，短松岡。"
            ],
            "下載": []
        },
        {
            "key": 11,
            "曲目": "十一",
            "詩名": "定風波",
            "作者": "蘇軾",
            "內容": [
                "莫聽穿林打葉聲，何妨吟嘯且徐行。竹杖芒鞋輕勝馬，誰怕？一簑煙雨任平生。",
                "料峭春風吹酒醒，微冷，山頭斜照卻相迎。回首向來蕭瑟處，歸去，也無風雨也無晴。"
            ],
            "下載": []
        },
        {
            "key": 12,
            "曲目": "十二",
            "詩名": "水調歌頭",
            "作者": "蘇軾",
            "內容": [
                "明月幾時有？把酒問青天。不知天上宮闕，今夕是何年？我欲乘風歸去，又恐瓊樓玉宇，高處不勝寒。起舞弄清影，何似在人間？",
                "轉朱閣，低綺戶，照無眠。不應有恨，何事長向別時圓？人有悲歡離合，月有陰晴圓缺，此事古難全。但願人長久，千里共嬋娟。"
            ],
            "下載": []
        },
        {
            "key": 13,
            "曲目": "十三",
            "詩名": "念奴嬌・赤壁懷古",
            "作者": "蘇軾",
            "內容": [
                "大江東去，浪淘盡，千古風流人物。故壘西邊，人道是，三國周郎赤壁。亂石崩雲，驚濤裂岸，捲起千堆雪。江山如畫，一時多少豪傑。",
                "遙想公瑾當年，小喬初嫁了，雄姿英發。羽扇綸巾，談笑間，強虜灰飛煙滅。故國神遊，多情應笑我，早生華髮。人間如夢，一尊還酹江月。"
            ],
            "下載": []
        },
        {
            "key": 14,
            "曲目": "十四",
            "詩名": "卜算子",
            "作者": "李之儀",
            "內容": [
                "我住長江頭，君住長江尾。日日思君不見君，共飲長江水。",
                "此水幾時休，此恨何時已。只願君心似我心，定不負相思意。"
            ],
            "下載": []
        },
        {
            "key": 15,
            "曲目": "十五",
            "詩名": "鵲橋仙",
            "作者": "秦觀",
            "內容": [
                "纖雲弄巧，飛星傳恨，銀漢迢迢暗度。金風玉露一相逢，便勝卻人間無數。",
                "柔情似水，佳期如夢，忍顧鵲橋歸路？兩情若是久長時，又豈在朝朝暮暮？"
            ],
            "下載": []
        },
        {
            "key": 16,
            "曲目": "十六",
            "詩名": "一剪梅",
            "作者": "李清照",
            "內容": [
                "紅藕香殘玉簟秋。輕解羅裳，獨上蘭舟。雲中誰寄錦書來，雁字回時，月滿西樓。",
                "花自飄零水自流，一種相思，兩處閒愁。此情無計可消除，才下眉頭，卻上心頭。"
            ],
            "下載": []
        },
        {
            "key": 17,
            "曲目": "十七",
            "詩名": "聲聲慢",
            "作者": "李清照",
            "內容": [
                "尋尋覓覓，冷冷清清，悽悽慘慘戚戚。乍暖還寒時候，最難將息。三杯兩盞淡酒，怎敵他、晚來風急？雁過也，正傷心，卻是舊時相識。",
                "滿地黃花堆積。憔悴損，如今有誰堪摘？守著窗兒，獨自怎生得黑？梧桐更兼細雨，到黃昏、點點滴滴。這次第，怎一個愁字了得？"
            ],
            "下載": []
        },
        {
            "key": 18,
            "曲目": "十八",
            "詩名": "醜奴兒",
            "作者": "辛棄疾",
            "內容": [
                "少年不識愁滋味，愛上層樓，愛上層樓。為賦新詞強說愁。",
                "而今識盡愁滋味，欲語還休，欲說還休，卻道天涼好個秋。"
            ],
            "下載": []
        },
        {
            "key": 19,
            "曲目": "十九",
            "詩名": "青玉案・元夕",
            "作者": "辛棄疾",
            "內容": [
                "東風夜放花千樹，更吹落、星如雨。寶馬雕車香滿路。鳳簫聲動，玉壺光轉，一夜魚龍舞。",
                "蛾兒雪柳黃金縷，笑語盈盈暗香去。眾裡尋他千百度。驀然回首，那人卻在，燈火闌珊處。"
            ],
            "下載": []
        },
        {
            "key": 20,
            "曲目": "廿",
            "詩名": "虞美人",
            "作者": "蔣捷",
            "內容": [
                "少年聽雨歌樓上，紅燭昏羅帳。壯年聽雨客舟中，江闊雲低，斷雁叫西風。",
                "而今聽雨僧廬下，鬢已星星也。悲歡離合總無情，一任階前，點滴到天明。"
            ],
            "下載": []
        },
    ],

}
const Poems2 = {
    "詩經": [
        {
            "key": 1,
            "曲目": "一",
            "詩名": "關雎",
            "作者": "詩經",
            "內容": [
                "關關雎鳩，在河之洲。",
                "窈窕淑女，君子好逑。",
                "參差荇菜，左右流之。",
                "窈窕淑女，寤寐求之。",
                "求之不得，寤寐思服。",
                "悠哉悠哉，輾轉反側。",
                "參差荇菜，左右采之。",
                "窈窕淑女，琴瑟友之。",
                "參差荇菜，左右芼之。",
                "窈窕淑女，鐘鼓樂之。"
            ],
            "下載": []
        },
        {
            "key": 2,
            "曲目": "二",
            "詩名": "螽斯",
            "作者": "詩經",
            "內容": [
                "螽斯羽，詵詵兮。",
                "宜爾子孫，振振兮。",
                "螽斯羽，薨薨兮。",
                "宜爾子孫，繩繩兮。",
                "螽斯羽，揖揖兮。",
                "宜爾子孫，蟄蟄兮。"
            ],
            "下載": []
        },
        {
            "key": 3,
            "曲目": "三",
            "詩名": "桃夭",
            "作者": "詩經",
            "內容": [
                "桃之夭夭，灼灼其華。",
                "之子于歸，宜其室家。",
                "桃之夭夭，有蕡其實。",
                "之子于歸，宜其家室。",
                "桃之夭夭，其葉蓁蓁。",
                "之子于歸，宜其家人。"
            ],
            "下載": []
        },
        {
            "key": 4,
            "曲目": "四",
            "詩名": "木瓜",
            "作者": "詩經",
            "內容": [
                "投我以木瓜，報之以瓊琚。",
                "匪報也，永以為好也!",
                "投我以木桃，報之以瓊瑤。",
                "匪報也，永以為好也!",
                "投我以木李，報之以瓊玖。",
                "匪報也，永以為好也!"
            ],
            "下載": []
        },
        {
            "key": 5,
            "曲目": "五",
            "詩名": "黍離",
            "作者": "詩經",
            "內容": [
                "彼黍離離，彼稷之苗。",
                "行邁靡靡，中心搖搖。",
                "知我者，謂我心憂;",
                "不知我者，謂我何求。",
                "悠悠蒼天，此何人哉?",
                "彼黍離離，彼稷之穗。",
                "行邁靡靡，中心如醉。",
                "知我者，謂我心憂;",
                "不知我者，謂我何求。",
                "悠悠蒼天，此何人哉?",
                "彼黍離離，彼稷之實。",
                "行邁靡靡，中心如噎。",
                "知我者，謂我心憂;",
                "不知我者，謂我何求。",
                "悠悠蒼天，此何人哉?"
            ],
            "下載": []
        },
        {
            "key": 6,
            "曲目": "六",
            "詩名": "采葛",
            "作者": "詩經",
            "內容": [
                "彼采葛兮，一日不見，如三月兮!",
                "彼采蕭兮，一日不見，如三秋兮!",
                "彼采艾兮!一日不見，如三歲兮!"
            ],
            "下載": []
        },
        {
            "key": 7,
            "曲目": "七",
            "詩名": "子衿",
            "作者": "詩經",
            "內容": [
                "青青子衿，悠悠我心。",
                "縱我不往，子寧不嗣音?",
                "青青子佩，悠悠我思。",
                "縱我不往，子寧不來?",
                "挑兮達兮，在城闕兮。",
                "一日不見，如三月兮。"
            ],
            "下載": []
        },
        {
            "key": 8,
            "曲目": "八",
            "詩名": "蒹葭",
            "作者": "詩經",
            "內容": [
                "蒹葭蒼蒼，白露為霜。",
                "所謂伊人，在水一方。",
                "溯洄從之，道阻且長。",
                "溯游從之，宛在水中央。",
                "蒹葭萋萋，白露未晞。",
                "所謂伊人，在水之湄。",
                "溯洄從之，道阻且躋。",
                "溯游從之，宛在水中坻。",
                "蒹葭采采，白露未已。",
                "所謂伊人，在水之涘。",
                "溯洄從之，道阻且右。",
                "溯游從之，宛在水中沚。"
            ],
            "下載": []
        }
    ],
    "古詩": [

        {
            "key": 1,
            "曲目": "十五",
            "詩名": "庭中有奇樹",
            "作者": "",
            "內容": [
                "庭中有奇樹，綠葉發華滋。",
                "攀條折其榮，將以遺所思。",
                "馨香盈懷袖，路遠莫致之。",
                "此物何足貴，但感別經時。"
            ],
            "下載": []
        },
        {
            "key": 2,
            "曲目": "十六",
            "詩名": "野田黃雀行",
            "作者": "曹植",
            "內容": [
                "高樹多悲風，海水揚其波。",
                "利劍不在掌，結友何須多?",
                "不見籬間雀，見鷂自投羅。",
                "羅家得雀喜，少年見雀悲。",
                "拔劍捎羅網，黃雀得飛飛。",
                "飛飛摩蒼天，來下謝少年。"
            ],
            "下載": []
        },
        {
            "key": 3,
            "曲目": "十七",
            "詩名": "茅屋為秋風所破歌",
            "作者": "杜甫",
            "內容": [
                "八月秋高風怒號，卷我屋上三重茅。",
                "茅飛度江灑江郊，高者掛罥長林梢，下者飄轉沉塘坳。",
                "南村群童欺我老無力，忍能對面為盜賊，公然抱茅入竹去。",
                "唇焦口燥呼不得，歸來倚杖自嘆息。",
                "俄頃風定雲墨色，秋天漠漠向昏黑。",
                "布衾多年冷似鐵，驕兒惡臥踏裏裂。",
                "床床屋漏無乾處，雨腳如麻未斷絕。",
                "自經喪亂少睡眠，長夜沾濕何由徹?",
                "安得廣廈千萬間，大庇天下寒士俱歡顏，風雨不動安如山。",
                "嗚呼!",
                "何時眼前突兀見此屋，吾廬獨破受凍死亦足!"
            ],
            "下載": []
        },
        {
            "key": 4,
            "曲目": "十八",
            "詩名": "歸園田居",
            "作者": "陶淵明",
            "內容": [
                "種豆南山下，草盛豆苗稀。",
                "晨興理荒穢，帶月荷鋤歸。",
                "道狹草木長，夕露沾我衣。",
                "衣沾不足惜，但使願無違。"
            ],
            "下載": []
        },
        {
            "key": 5,
            "曲目": "十九",
            "詩名": "白雪歌送武判官歸京",
            "作者": "岑參",
            "內容": [
                "北風捲地白草折，胡天八月即飛雪。",
                "忽如一夜春風來，千樹萬樹梨花開。",
                "散入珠簾溼羅幕，狐裘不暖錦衾薄。",
                "將軍角弓不得控，都護鐵衣冷難著。",
                "瀚海闌干百丈冰，愁雲慘淡萬里凝。",
                "中軍置酒飲歸客，胡琴琵琶與羌笛。",
                "紛紛暮雪下轅門，風掣紅旗凍不翻。",
                "輪臺東門送君去，去時雪滿天山路。",
                "山迴路轉不見君，雪上空留馬行處。"
            ],
            "下載": []
        }
    ],
    "五言絕句": [
        {
            "key": 12,
            "曲目": "一",
            "詩名": "渡漢江",
            "作者": "宋之問",
            "內容": [
                "嶺外音書絕，",
                "經冬復歷春。",
                "近鄉情更怯，",
                "不敢問來人。"
            ],
            "下載": []
        },
        {
            "key": 13,
            "曲目": "二",
            "詩名": "送別",
            "作者": "王維",
            "內容": [
                "山中相送罷，",
                "日暮掩柴扉。",
                "春草明年綠，",
                "王孫歸不歸?"
            ],
            "下載": []
        },
        {
            "key": 14,
            "曲目": "三",
            "詩名": "鳥鳴澗",
            "作者": "王維",
            "內容": [
                "人閒桂花落，",
                "夜靜春山空。",
                "月出驚山鳥，",
                "時鳴春澗中。"
            ],
            "下載": []
        },
        {
            "key": 15,
            "曲目": "四",
            "詩名": "鹿柴",
            "作者": "王維",
            "內容": [
                "空山不見人，",
                "但聞人語響。",
                "返景入深林，",
                "復照青苔上。"
            ],
            "下載": []
        },
        {
            "key": 16,
            "曲目": "五",
            "詩名": "竹里館",
            "作者": "王維",
            "內容": [
                "獨坐幽篁裏，",
                "彈琴復長嘯。",
                "深林人不知，",
                "明月來相照。"
            ],
            "下載": []
        },
        {
            "key": 17,
            "曲目": "六",
            "詩名": "相思",
            "作者": "王維",
            "內容": [
                "紅豆生南國，",
                "春來發幾枝。",
                "願君多采擷，",
                "此物最相思。"
            ],
            "下載": []
        },
        {
            "key": 18,
            "曲目": "七",
            "詩名": "終南望餘雪",
            "作者": "祖詠",
            "內容": [
                "終南陰嶺秀，",
                "積雪浮雲端。",
                "林表明霽色，",
                "城中增暮寒。"
            ],
            "下載": []
        },
        {
            "key": 19,
            "曲目": "八",
            "詩名": "玉階怨",
            "作者": "李白",
            "內容": [
                "玉階生白露，",
                "夜久侵羅襪。",
                "卻下水晶簾，",
                "玲瓏望秋月。"
            ],
            "下載": []
        },
        {
            "key": 20,
            "曲目": "九",
            "詩名": "自遣",
            "作者": "李白",
            "內容": [
                "對酒不覺暝，",
                "落花盈我衣。",
                "醉起步溪月，",
                "鳥還人亦稀。"
            ],
            "下載": []
        },
        {
            "key": 21,
            "曲目": "十",
            "詩名": "長干行",
            "作者": "崔顥",
            "內容": [
                "君家何處住?",
                "妾住在橫塘。",
                "停船暫借問，",
                "或恐是同鄉。"
            ],
            "下載": []
        },
        {
            "key": 22,
            "曲目": "十一",
            "詩名": "八陣圖",
            "作者": "杜甫",
            "內容": [
                "功蓋三分國，",
                "名成八陣圖。",
                "江流石不轉，",
                "遺恨失吞吳。"
            ],
            "下載": []
        },
        {
            "key": 23,
            "曲目": "十二",
            "詩名": "送靈澈上人",
            "作者": "劉長卿",
            "內容": [
                "蒼蒼竹林寺，",
                "杳杳鐘聲晚。",
                "荷笠帶斜陽，",
                "青山獨歸遠。"
            ],
            "下載": []
        },
        {
            "key": 24,
            "曲目": "十三",
            "詩名": "登樓",
            "作者": "韋應物",
            "內容": [
                "茲樓日登眺，",
                "流歲暗蹉跎。",
                "坐厭淮南守，",
                "秋山紅樹多。"
            ],
            "下載": []
        },
        {
            "key": 25,
            "曲目": "十四",
            "詩名": "和張僕射塞下曲",
            "作者": "盧綸",
            "內容": [
                "月黑雁飛高，",
                "單于夜遁逃。",
                "欲將輕騎逐，",
                "大雪滿弓刀。"
            ],
            "下載": []
        },
        {
            "key": 26,
            "曲目": "十五",
            "詩名": "問劉十九",
            "作者": "白居易",
            "內容": [
                "綠螘新醅酒，",
                "紅泥小火爐。",
                "晚來天欲雪，",
                "能飲一杯無?"
            ],
            "下載": []
        },
        {
            "key": 27,
            "曲目": "十六",
            "詩名": "山村詠懷",
            "作者": "邵雍",
            "內容": [
                "一去二三里，",
                "煙村四五家。",
                "亭臺六七座，",
                "八九十枝花。"
            ],
            "下載": []
        }
    ],
    "七言絕句": [
        {
            "key": 1,
            "曲目": "一",
            "詩名": "詠柳",
            "作者": "賀知章",
            "內容": [
                "碧玉妝成一樹高，",
                "萬條垂下綠絲絛。",
                "不知細葉誰裁出，",
                "二月春風似剪刀。"
            ],
            "下載": []
        },
        {
            "key": 2,
            "曲目": "二",
            "詩名": "桃花溪",
            "作者": "張旭",
            "內容": [
                "隱隱飛橋隔野煙，",
                "石磯西畔問漁船。",
                "桃花盡日隨流水，",
                "洞在清溪何處邊。"
            ],
            "下載": []
        },
        {
            "key": 3,
            "曲目": "三",
            "詩名": "涼州詞",
            "作者": "王翰",
            "內容": [
                "葡萄美酒夜光杯，",
                "欲飲琵琶馬上催。",
                "醉臥沙場君莫笑，",
                "古來征戰幾人回?"
            ],
            "下載": []
        },
        {
            "key": 4,
            "曲目": "四",
            "詩名": "涼州詞",
            "作者": "王之渙",
            "內容": [
                "黃河遠上白雲間，",
                "一片孤城萬仞山。",
                "羌笛何須怨楊柳，",
                "春風不度玉門關。"
            ],
            "下載": []
        },
        {
            "key": 5,
            "曲目": "五",
            "詩名": "贈汪倫",
            "作者": "李白",
            "內容": [
                "李白乘舟將欲行，",
                "忽聞岸上踏歌聲。",
                "桃花潭水深千尺，",
                "不及汪倫送我情。"
            ],
            "下載": []
        },
        {
            "key": 6,
            "曲目": "六",
            "詩名": "望廬山瀑布",
            "作者": "李白",
            "內容": [
                "日照香爐生紫煙，",
                "遙看瀑布掛前川。",
                "飛流直下三千尺，",
                "疑是銀河落九天。"
            ],
            "下載": []
        },
        {
            "key": 7,
            "曲目": "七",
            "詩名": "清平調.其一",
            "作者": "李白",
            "內容": [
                "雲想衣裳花想容，",
                "春風拂檻露華濃。",
                "若非 玉山頭見，",
                "會向瑤臺月下逢。"
            ],
            "下載": []
        },
        {
            "key": 8,
            "曲目": "八",
            "詩名": "絕句",
            "作者": "杜甫",
            "內容": [
                "兩個黃鸝鳴翠柳，",
                "一行白鷺上青天。",
                "窗含西嶺千秋雪，",
                "門泊東吳萬里船。"
            ],
            "下載": []
        },
        {
            "key": 9,
            "曲目": "九",
            "詩名": "逢入京使",
            "作者": "岑參",
            "內容": [
                "故園東望路漫漫，",
                "雙袖龍鍾淚不乾。",
                "馬上相逢無紙筆，",
                "憑君傳語報平安。"
            ],
            "下載": []
        },
        {
            "key": 10,
            "曲目": "十",
            "詩名": "江南春",
            "作者": "杜牧",
            "內容": [
                "千里鶯啼綠映紅，",
                "水村山郭酒旗風。",
                "南朝四百八十寺，",
                "多少樓臺煙雨中。"
            ],
            "下載": []
        },
        {
            "key": 11,
            "曲目": "十一",
            "詩名": "嫦娥",
            "作者": "李商隱",
            "內容": [
                "雲母屏風燭影深，",
                "長河漸落曉星沉。",
                "嫦娥應悔偷靈藥，",
                "碧海青天夜夜心。"
            ],
            "下載": []
        },
        {
            "key": 12,
            "曲目": "十二",
            "詩名": "元日",
            "作者": "王安石",
            "內容": [
                "爆竹聲中一歲除，",
                "春風送暖入屠蘇。",
                "千門萬戶曈曈日，",
                "總把新桃換舊符。"
            ],
            "下載": []
        },
        {
            "key": 13,
            "曲目": "十三",
            "詩名": "小池",
            "作者": "楊萬里",
            "內容": [
                "泉眼無聲惜細流，",
                "樹陰照水愛晴柔。",
                "小荷才露尖尖角，",
                "早有蜻蜓立上頭。"
            ],
            "下載": []
        },
        {
            "key": 14,
            "曲目": "十四",
            "詩名": "贈劉景文",
            "作者": "蘇軾",
            "內容": [
                "荷盡已無擎雨蓋，",
                "菊殘猶有傲霜枝。",
                "一年好景君須記，",
                "最是橙黃橘綠時。"
            ],
            "下載": []
        },
        {
            "key": 15,
            "曲目": "十五",
            "詩名": "觀書有感",
            "作者": "朱熹",
            "內容": [
                "半畝方塘一鑑開，",
                "天光雲影共徘徊。",
                "問渠哪得清如許?",
                "為有源頭活水來。"
            ],
            "下載": []
        },
        {
            "key": 16,
            "曲目": "十六",
            "詩名": "春日",
            "作者": "朱熹",
            "內容": [
                "勝日尋芳泗水濱，",
                "無邊光景一時新。",
                "等閒識得東風面，",
                "萬紫千紅總是春。"
            ],
            "下載": []
        },
        {
            "key": 17,
            "曲目": "十七",
            "詩名": "石灰吟",
            "作者": "于謙",
            "內容": [
                "千錘萬鑿出深山，",
                "烈火焚燒若等閒。",
                "粉骨碎身全不怕，",
                "要留清白在人間。"
            ],
            "下載": []
        },
        {
            "key": 18,
            "曲目": "十八",
            "詩名": "竹石",
            "作者": "鄭燮",
            "內容": [
                "咬定青山不放鬆，",
                "立根原在破岩中。",
                "千磨萬擊還堅勁，",
                "任爾東西南北風。"
            ],
            "下載": []
        },
        {
            "key": 19,
            "曲目": "十九",
            "詩名": "己亥雜詩",
            "作者": "龔自珍",
            "內容": [
                "浩蕩離愁白日斜，",
                "吟鞭東指即天涯。",
                "落紅不是無情物，",
                "化作春泥更護花。"
            ],
            "下載": []
        }
    ],
    "五言律詩": [
        {
            "key": 10,
            "曲目": "一",
            "詩名": "輞川閒居贈裴秀才迪",
            "作者": "王維",
            "內容": [
                "寒山轉蒼翠，秋水日潺湲。",
                "倚杖柴門外，臨風聽暮蟬。",
                "渡頭餘落日，墟里上孤煙。",
                "復值接輿醉，狂歌五柳前。"
            ],
            "下載": []
        },
        {
            "key": 11,
            "曲目": "二",
            "詩名": "過香積寺",
            "作者": "王維",
            "內容": [
                "不知香積寺，數里入雲峰。",
                "古木無人徑，深山何處鐘。",
                "泉聲咽危石，日色冷青松。",
                "薄暮空潭曲，安禪制毒龍。"
            ],
            "下載": []
        },
        {
            "key": 12,
            "曲目": "三",
            "詩名": "望月懷遠",
            "作者": "張九齡",
            "內容": [
                "海上生明月，天涯共此時。",
                "情人怨遙夜，竟夕起相思。",
                "滅燭憐光滿，披衣覺露滋。",
                "不堪盈手贈，還寢夢佳期。"
            ],
            "下載": []
        },
        {
            "key": 13,
            "曲目": "四",
            "詩名": "訪戴天山道士不遇",
            "作者": "李白",
            "內容": [
                "犬吠水聲中，桃花帶雨濃。",
                "樹深時見鹿，溪午不聞鐘。",
                "野竹分青靄，飛泉掛碧 。",
                "無人知所去，愁倚兩三松。"
            ],
            "下載": []
        },
        {
            "key": 14,
            "曲目": "五",
            "詩名": "月夜憶舍弟",
            "作者": "杜甫",
            "內容": [
                "戍鼓斷人行，邊秋一雁聲。",
                "露從今夜白，月是故鄉明。",
                "有弟皆分散，無家問死生。",
                "寄書長不達，況乃未休兵。"
            ],
            "下載": []
        },
        {
            "key": 15,
            "曲目": "六",
            "詩名": "春夜喜雨",
            "作者": "杜甫",
            "內容": [
                "好雨知時節，當春乃發生。",
                "隨風潛入夜，潤物細無聲。",
                "野徑雲俱黑，江船火獨明。",
                "曉看紅濕處，花重錦官城。"
            ],
            "下載": []
        }
    ],
    "七言律詩": [
        {
            "key": 9,
            "曲目": "一",
            "詩名": "客至",
            "作者": "杜甫",
            "內容": [
                "舍南舍北皆春水，",
                "但見 鷗日日來。",
                "花徑不曾緣客掃，",
                "蓬門今始為君開。",
                "盤飧市遠無兼味，",
                "樽酒家貧只舊醅。",
                "肯與鄰翁相對飲，",
                "隔籬呼取盡餘杯。"
            ],
            "下載": []

        },
        {
            "key": 10,
            "曲目": "二",
            "詩名": "登高",
            "作者": "杜甫",
            "內容": [
                "風急天高猿嘯哀，",
                "渚清沙白鳥飛回。",
                "無邊落木蕭蕭下，",
                "不盡長江滾滾來。",
                "萬里悲秋常作客，",
                "百年多病獨登臺。",
                "艱難苦恨繁霜鬢，",
                "潦倒新停濁酒杯。"
            ],
            "下載": []
        },
        {
            "key": 11,
            "曲目": "三",
            "詩名": "左遷至藍關示姪孫湘",
            "作者": "韓愈",
            "內容": [
                "一封朝奏九重天，",
                "夕貶潮州路八千。",
                "欲為聖明除弊事，",
                "肯將衰朽惜殘年?",
                "雲橫秦嶺家何在?",
                "雪擁藍關馬不前。",
                "知汝遠來應有意，",
                "好收吾骨瘴江邊。"
            ],
            "下載": []
        },
        {
            "key": 12,
            "曲目": "四",
            "詩名": "錦瑟",
            "作者": "李商隱",
            "內容": [
                "錦瑟無端五十弦，",
                "一弦一柱思華年。",
                "莊生曉夢迷蝴蝶，",
                "望帝春心託杜鵑。",
                "滄海月明珠有淚，",
                "藍田日暖玉生煙。",
                "此情可待成追憶?",
                "只是當時已惘然。"
            ],
            "下載": []
        },
        {
            "key": 13,
            "曲目": "五",
            "詩名": "過陳琳墓",
            "作者": "溫庭筠",
            "內容": [
                "曾於青史見遺文，",
                "今日飄蓬過此墳。",
                "詞客有靈應識我，",
                "霸才無主獨憐君。",
                "石麟埋沒藏春草，",
                "銅雀荒涼對暮雲。",
                "莫怪臨風倍惆悵，",
                "欲將書劍學從軍。"
            ],
            "下載": []
        },
        {
            "key": 14,
            "曲目": "六",
            "詩名": "遊山西村",
            "作者": "陸游",
            "內容": [
                "莫笑農家臘酒渾，",
                "豐年留客足雞豚。",
                "山重水複疑無路，",
                "柳暗花明又一村。",
                "簫鼓追隨春社近，",
                "衣冠簡樸古風存。",
                "從今若許閒乘月，",
                "拄杖無時夜叩門。"
            ],
            "下載": []
        }
    ],
    "元曲": [
        {
            "key": 1,
            "曲目": "一",
            "詩名": "天淨沙.春",
            "作者": "白樸",
            "內容": [
                "春山暖日和風，",
                "闌干樓閣簾櫳，",
                "楊柳鞦韆院中。",
                "啼鶯舞燕，",
                "小橋流水飛紅。"
            ],
            "下載": []
        },
        {
            "key": 2,
            "曲目": "二",
            "詩名": "天淨沙.夏",
            "作者": "白樸",
            "內容": [
                "雲收雨過波添，",
                "樓高水冷瓜甜，",
                "綠樹陰垂畫檐。",
                "紗廚藤簟，",
                "玉人羅扇輕縑。"
            ],
            "下載": []
        },
        {
            "key": 3,
            "曲目": "三",
            "詩名": "天淨沙.秋",
            "作者": "白樸",
            "內容": [
                "孤村落日殘霞，",
                "輕煙老樹寒鴉，",
                "一點飛鴻影下。",
                "青山綠水，",
                "白草紅葉黃花。"
            ],
            "下載": []
        },
        {
            "key": 4,
            "曲目": "四",
            "詩名": "天淨沙.冬",
            "作者": "白樸",
            "內容": [
                "一聲畫角譙門，",
                "半庭新月黃昏，",
                "雪裏山前水濱。",
                "竹籬茅舍，",
                "淡煙衰草孤村。"
            ],
            "下載": []
        },
        {
            "key": 5,
            "曲目": "五",
            "詩名": "沉醉東風.漁",
            "作者": "白樸",
            "內容": [
                "黃蘆岸，白蘋渡口，",
                "綠楊堤，紅蓼灘頭。",
                "雖無刎頸交，卻有忘機友。",
                "點秋江、白鷺沙鷗，",
                "傲殺人間萬戶侯，",
                "不識字、煙波釣叟。"
            ],
            "下載": []
        },
        {
            "key": 6,
            "曲目": "六",
            "詩名": "平湖樂.採菱人語隔秋煙",
            "作者": "王惲",
            "內容": [
                "採菱人語隔秋煙，",
                "波靜如橫練。",
                "入手風光莫流轉，",
                "共留連，畫船一笑春風面。",
                "江山信美，終非吾土，",
                "問何日是歸年?"
            ],
            "下載": []
        },
        {
            "key": 7,
            "曲目": "七",
            "詩名": "大德歌.秋",
            "作者": "關漢卿",
            "內容": [
                "風飄飄，雨瀟瀟，",
                "便做陳摶也睡不著。",
                "懊惱傷懷抱，撲簌簌淚點拋。",
                "秋蟬兒噪罷寒蛩兒叫，",
                "淅零零細雨打芭蕉。"
            ],
            "下載": []
        },
        {
            "key": 8,
            "曲目": "八",
            "詩名": "天淨沙.秋思",
            "作者": "馬致遠",
            "內容": [
                "枯藤老樹昏鴉，",
                "小橋流水人家，",
                "古道西風瘦馬。",
                "夕陽西下，",
                "斷腸人在天涯。"
            ],
            "下載": []
        },
        {
            "key": 9,
            "曲目": "九",
            "詩名": "山坡羊.驪山懷古",
            "作者": "張養浩",
            "內容": [
                "驪山四顧，阿房一炬，",
                "當時奢侈今何處?",
                "只見草蕭疏，水縈紆。",
                "至今遺恨迷煙樹。",
                "列國周齊秦漢楚，",
                "贏，都變做了土;",
                "輸，都變做了土。"
            ],
            "下載": []
        },
        {
            "key": 10,
            "曲目": "十",
            "詩名": "水仙子.詠江南",
            "作者": "張養浩",
            "內容": [
                "一江煙水照晴嵐，",
                "兩岸人家接畫檐，",
                "芰荷叢一段秋光淡。",
                "看沙鷗舞再三，",
                "卷香風十里珠簾。",
                "畫船兒天邊至，",
                "酒旗兒風外颭。",
                "愛殺江南!"
            ],
            "下載": []
        }
    ],
}
const Poems3 = {
    "論辯": [
        {
            "key": 1,
            "曲目": "一",
            "詩名": "天下莫能與之爭",
            "作者": "春秋 老聃",
            "內容": [
                "曲則全，枉則直，窪則盈，弊則新，少則得，多則惑。是以聖人抱一為天下式。不自見，故明；不自是，故彰；不自伐，故有功；不自矜，故長。夫唯不爭，故天下莫能與之爭。古之所謂曲則全者，豈虛言哉？誠全而歸之。"
            ],
            "下載": []
        },
        {
            "key": 2,
            "曲目": "二",
            "詩名": "燭之武退秦師 ",
            "作者": "春秋 左丘明",
            "內容": [
                "晉侯、秦伯圍鄭，以其無禮於晉，且貳於楚也。晉軍函陵，秦軍氾南。佚之狐言於鄭伯曰：「國危矣，若使燭之武見秦君，師必退。」公從之。辭曰：「臣之壯也，猶不如人；今老矣，無能爲也已」。公曰：「吾不能早用子，今急而求子，是寡人之過也。然鄭亡，子亦有不利焉！」許之。"
            ],
            "下載": []
        },
        {
            "key": 3,
            "曲目": "三",
            "詩名": "孔子論孝 ",
            "作者": "孝經",
            "內容": [
                "仲尼居，曾子侍。子曰：「先王有至德要道，以順天下，民用和睦，上下無怨。汝知之乎？」曾子避席曰：「參不敏，何足以知之？」子曰：「夫孝，德之本也，教之所由生也。復坐，吾語汝。身體髮膚，受之父母，不敢毀傷，孝之始也。立身行道，揚名於後世，以顯父母，孝之終也。夫孝，始於事親，中於事君，終於立身。」"
            ],
            "下載": []
        },
        {
            "key": 4,
            "曲目": "四",
            "詩名": "予豈好辯哉",
            "作者": "戰國 孟子（孟軻）",
            "內容": [
                "昔者禹抑洪水而天下平，周公兼夷狄驅猛獸而百姓寧，孔子成《春秋》而亂臣賊子懼。《詩》云：「戎狄是膺，荊舒是懲，則莫我敢承。」無父無君，是周公所膺也。我亦欲正人心，息邪說，距詖行，放淫辭，以承三聖者；豈好辯哉？予不得已也。能言距楊墨者，聖人之徒也。"
            ],
            "下載": []
        },
        {
            "key": 5,
            "曲目": "五",
            "詩名": "生於憂患死於安樂",
            "作者": "戰國 孟子（孟軻）",
            "內容": [
                "舜發於畎畝之中，傅說舉於版築之閒，膠鬲舉於魚鹽之中，管夷吾舉於士，孫叔敖舉於海，百里奚舉於市。故天將降大任於是人也，必先苦其心志，勞其筋骨，餓其體膚，空乏其身，行拂亂其所為，所以動心忍性，曾益其所不能。人恒過，然後能改；困於心，衡於慮，而後作；徵於色，發於聲，而後喻。入則無法家拂士，出則無敵國外患者，國恒亡。然後知生於憂患而死於安樂也。"
            ],
            "下載": []
        },
        {
            "key": 6,
            "曲目": "六",
            "詩名": "四端",
            "作者": "戰國 孟子（孟軻）",
            "內容": [
                "人皆有不忍人之心。先王有不忍人之心，斯有不忍人之政矣。以不忍人之心，行不忍人之政，治天下可運之掌上。所以謂人皆有不忍人之心者，今人乍見孺子將入於井，皆有怵惕惻隱之心。非所以內交於孺子之父母也，非所以要譽於鄉黨朋友也，非惡其聲而然也。由是觀之，無惻隱之心，非人也；無羞惡之心，非人也；無辭讓之心，非人也；無是非之心，非人也。惻隱之心，仁之端也；羞惡之心，義之端也；辭讓之心，禮之端也；是非之心，智之端也。人之有是四端也，猶其有四體也。"
            ],
            "下載": []
        },
        {
            "key": 7,
            "曲目": "七",
            "詩名": "逍遙遊",
            "作者": "戰國 莊子（莊周）",
            "內容": [
                "舉世而譽之而不加勸，舉世而非之而不加沮，定乎內外之分，辯乎榮辱之竟，斯已矣；彼其於世，未數數然也。雖然，猶有未樹也。夫列子御風而行，冷然善也，旬有五日而後反；彼於致福者，未數數然也。此雖免乎行，猶有所待者也。若夫乘天地之正，而御六氣之辯，以遊無窮者，彼且惡乎待哉！故曰：至人無己，神人無功，聖人無名。"
            ],
            "下載": []
        },
        {
            "key": 8,
            "曲目": "八",
            "詩名": "養生主",
            "作者": " 戰國  莊子（莊周）",
            "內容": [
                "吾生也有涯，而知也無涯。以有涯隨無涯，殆已；已而為知者，殆而已矣。為善無近名，為惡無近刑，緣督以為經，可以保身，可以全生，可以養親，可以盡年。"
            ],
            "下載": []
        },
        {
            "key": 9,
            "曲目": "九",
            "詩名": "漁父",
            "作者": "戰國 屈原",
            "內容": [
                "漁父曰：「聖人不凝滯於物，而能與世推移。世人皆濁，何不淈其泥而揚其波？衆人皆醉，何不哺其糟而歠其醨？何故深思高舉，自令放爲？」屈原曰：「吾聞之，新沐者必彈冠，新浴者必振衣；安能以身之察察，受物之汶汶者乎？寧赴湘流，葬於江魚之腹中。安能以皓皓之白，而蒙世俗之塵埃乎?」"
            ],
            "下載": []
        },
        {
            "key": 10,
            "曲目": "十",
            "詩名": "天論",
            "作者": "戰國 荀子（荀況）",
            "內容": [
                "天行有常，不為堯存，不為桀亡。應之以治則吉，應之以亂則凶。彊本而節用，則天不能貧；養備而動時，則天不能病；循道而不貳，則天不能禍。故水旱不能使之飢，寒暑不能使之疾，祆怪不能使之凶。本荒而用侈，則天不能使之富；養略而動罕，則天不能使之全；倍道而妄行，則天不能使之吉。"
            ],
            "下載": []
        },
        {
            "key": 11,
            "曲目": "十一",
            "詩名": "勸學",
            "作者": "戰國 荀子（荀況）",
            "內容": [
                "積土成山，風雨興焉；積水成淵，蛟龍生焉；積善成德，而神明自得，聖心備焉。故不積蹞步，無以致千里；不積小流，無以成江海。騏驥一躍，不能十步；駑馬十駕，功在不舍。鍥而舍之，朽木不折；鍥而不舍，金石可鏤。螾無爪牙之利，筋骨之強，上食埃土，下飲黃泉，用心一也。蟹八跪而二螯，非蛇蟺之穴，無可寄託者，用心躁也。"
            ],
            "下載": []
        },
        {
            "key": 12,
            "曲目": "十二",
            "詩名": "貴公",
            "作者": "戰國 呂氏春秋",
            "內容": [
                "天下非一人之天下也，天下之天下也。陰陽之和，不長一類；甘露時雨，不私一物；萬民之主，不阿一人。伯禽將行，請所以治魯，周公曰：「利而勿利也。」荊人有遺弓者，而不肯索，曰：「荊人遺之，荊人得之，又何索焉？」孔子聞之曰：「去其『荊』而可矣。」老聃聞之曰：「去其『人』而可矣。」故老聃則至公矣。天地大矣，生而弗子，成而弗有，萬物皆被其澤、得其利，而莫知其所由始，此三皇、五帝之德也。"
            ],
            "下載": []
        },
        {
            "key": 13,
            "曲目": "十三",
            "詩名": "鷸蚌相爭",
            "作者": "戰國策",
            "內容": [
                "趙且伐燕，蘇代爲燕謂惠王曰：「今者臣來，過易水。蚌方出曝，而鷸啄其肉，蚌合而箝其喙。鷸曰：『今日不雨，明日不雨，即有死蚌！』蚌亦謂鷸曰：『今日不出，明日不出，即有死鷸！』兩者不肯相舍，漁者得而並禽之。今趙且伐燕，燕趙久相支，以弊大衆，臣恐強秦之爲漁夫也。故願王之熟計之也！」惠王曰：「善。」乃止。"
            ],
            "下載": []
        },
        {
            "key": 14,
            "曲目": "十四",
            "詩名": "禮記禮運",
            "作者": "西漢 戴聖",
            "內容": [
                "大道之行也，天下為公。選賢與能，講信修睦，故人不獨親其親，不獨子其子，使老有所終，壯有所用，幼有所長，矜寡孤獨廢疾者，皆有所養。男有分，女有歸。貨惡其棄於地也，不必藏於己；力惡其不出於身也，不必為己。是故謀閉而不興，盜竊亂賊而不作，故外戶而不閉，是謂大同。"
            ],
            "下載": []
        },
        {
            "key": 15,
            "曲目": "十五",
            "詩名": "中庸",
            "作者": "西漢 戴聖",
            "內容": [
                "天命之謂性，率性之謂道，修道之謂教。道也者，不可須臾離也，可離，非道也。是故君子戒慎乎其所不睹，恐懼乎其所不聞。莫見乎隱，莫顯乎微，故君子慎其獨也。喜怒哀樂之未發謂之中，發而皆中節謂之和。中也者，天下之大本也；和也者，天下之達道也。致中和，天地位焉，萬物育焉。"
            ],
            "下載": []
        },
        {
            "key": 16,
            "曲目": "十六",
            "詩名": "大學",
            "作者": "西漢 戴聖",
            "內容": [
                "古之欲明明德於天下者，先治其國；欲治其國者，先齊其家；欲齊其家者，先修其身；欲修其身者，先正其心；欲正其心者，先誠其意；欲誠其意者，先致其知，致知在格物。物格而後知至，知至而後意誠，意誠而後心正，心正而後身修，身修而後家齊，家齊而後國治，國治而後天下平。自天子以至於庶人，壹是皆以修身為本。"
            ],
            "下載": []
        },
        {
            "key": 17,
            "曲目": "十七",
            "詩名": "論六家要旨",
            "作者": "西漢 司馬談",
            "內容": [
                "嘗竊觀陰陽之術，大祥而眾忌諱，使人拘而多所畏；然其序四時之大順，不可失也。儒者博而寡要，勞而少功，是以其事難盡從；然其序君臣父子之禮，列夫婦長幼之別，不可易也。墨者儉而難遵，是以其事不可徧循；然其彊本節用，不可廢也。法家嚴而少恩；然其正君臣上下之分，不可改矣。名家使人儉而善失真；然其正名實，不可不察也。道家使人精神專一，動合無形，贍足萬物。其為術也，因陰陽之大順，采儒墨之善，撮名法之要，與時遷移，應物變化，立俗施事，無所不宜，指約而易操，事少而功多。"
            ],
            "下載": []
        },
        {
            "key": 18,
            "曲目": "十八",
            "詩名": "典論論文 ",
            "作者": "三國 曹丕",
            "內容": [
                "蓋文章，經國之大業，不朽之盛事。年壽有時而盡，榮樂止乎其身，二者必至之常期，未若文章之無窮。是以古之作者，寄身於翰墨，見意於篇籍，不假良史之辭，不託飛馳之勢，而聲名自傳於後。故西伯幽而演易，周旦顯而制禮，不以隱約而弗務，不以康樂而加思。夫然，則古人賤尺璧而重寸陰，懼乎時之過已。而人多不強力，貧賤則懾於饑寒，富貴則流於逸樂，營遂目前之務，而遺千載之功。日月逝於上，體貌衰於下，忽然與萬物遷化，斯志士之大痛也！"
            ],
            "下載": []
        },
        {
            "key": 19,
            "曲目": "十九",
            "詩名": "讀孟嘗君傳",
            "作者": "北宋 王安石",
            "內容": [
                "世皆稱孟嘗君能得士，士以故歸之，而卒賴其力以脫於虎豹之秦。嗟乎！孟嘗君特雞鳴狗盜之雄耳，豈足以言得士？不然，擅齊之強，得一士焉，宜可以南面而制秦，尚何取雞鳴狗盜之力哉？夫雞鳴狗盜之出其門，此士之所以不至也。"
            ],
            "下載": []
        },
        {
            "key": 20,
            "曲目": "二十",
            "詩名": "刑賞忠厚之至論",
            "作者": "北宋 蘇軾",
            "內容": [
                "古者賞不以爵祿，刑不以刀鋸。賞之以爵祿，是賞之道行於爵祿之所加，而不行於爵祿之所不加也。刑之以刀鋸，是刑之威施於刀鋸之所及，而不施於刀鋸之所不及也。先王知天下之善不勝賞，而爵祿不足以勸也；知天下之惡不勝刑，而刀鋸不足以裁也。是故疑則舉而歸之於仁，以君子長者之道待天下，使天下相率而歸於君子長者之道。故曰：忠厚之至也。"
            ],
            "下載": []
        },
        {
            "key": 21,
            "曲目": "二十一",
            "詩名": "留侯論",
            "作者": "北宋 蘇軾",
            "內容": [
                "古之所謂豪傑之士者，必有過人之節。人情有所不能忍者，匹夫見辱，拔劍而起，挺身而鬥，此不足爲勇也。天下有大勇者，卒然臨之而不驚，無故加之而不怒。此其所挾持者甚大，而其志甚遠也。觀夫高祖之所以勝，而項籍之所以敗者，在能忍與不能忍之間而已矣。項籍唯不能忍，是以百戰百勝而輕用其鋒；高祖忍之，養其全鋒而待其弊，此子房教之也。當淮陰破齊而欲自王，高祖發怒，見於詞色。由此觀之，猶有剛強不忍之氣，非子房其誰全之？"
            ],
            "下載": []
        },
        {
            "key": 22,
            "曲目": "二十二",
            "詩名": "良馬對",
            "作者": "南宋 岳飛",
            "內容": [
                "臣有二馬，日啗芻豆數斗，飲泉一斛，然非精潔即不受；介而馳，初不甚疾，比行百里，始奮迅，自午至酉，猶可二百里，褫鞍甲而不息不汗，若無事然。此其受大而不苟取，力裕而不求逞，致遠之材也。不幸相繼以死。今所乘者，日不過數升，而秣不擇粟，飲不擇泉，攬轡未安，踴躍疾驅，甫百里，力竭汗喘，殆欲斃然。此其寡取易盈，好逞易窮，駑鈍之材也。"
            ],
            "下載": []
        },
        {
            "key": 23,
            "曲目": "二十三",
            "詩名": "司馬季主論卜",
            "作者": "明 劉基",
            "內容": [
                "有昔者，必有今日，是故碎瓦頹垣，昔日之歌樓舞館也。荒榛斷梗，昔日之瓊蕤玉樹也。露蠶風蟬，昔日之鳳笙龍笛也。鬼燐螢火，昔日之金缸華燭也。秋荼春薺，昔日之象白駝峯也。丹楓白荻，昔日之蜀錦齊紈也。昔日之所無，今日有之不爲過；昔日之所有，今日無之不爲不足。是故一晝一夜，華開者謝；一秋一春，物故者新。激湍之下，必有深潭；高丘之下，必有浚谷。"
            ],
            "下載": []
        },
        {
            "key": 24,
            "曲目": "二十四",
            "詩名": "深慮論",
            "作者": "明 方孝孺",
            "內容": [
                "古之聖人，知天下後世之變，非智慮之所能周，非法術之所能制；不敢肆其私謀詭計，而惟積至誠、用大德，以結乎天心；使天眷其德，若慈母之保赤子而不忍釋。故其子孫，雖有至愚不肖者足以亡國，而天卒不忍遽亡之，此慮之遠者也。"
            ],
            "下載": []
        }
    ],
    "序跋": [
        {
            "key": 1,
            "曲目": "一",
            "詩名": "蘭亭集序",
            "作者": "東晉 王羲之",
            "內容": [
                "永和九年，歲在癸丑，暮春之初，會於會稽山陰之蘭亭，修禊事也。群賢畢至，少長咸集。此地有崇山峻嶺，茂林修竹；又有清流激湍，映帶左右，引以爲流觴曲水，列坐其次。雖無絲竹管絃之盛，一觴一詠，亦足以暢敘幽情。是日也，天朗氣清，惠風和暢，仰觀宇宙之大，俯察品類之盛，所以遊目騁懷，足以極視聽之娛，信可樂也。"
            ],
            "下載": []
        },
        {
            "key": 2,
            "曲目": "二",
            "詩名": "春夜宴桃李園序",
            "作者": "唐 李白",
            "內容": [
                "夫天地者，萬物之逆旅也；光陰者，百代之過客也。而浮生若夢，為歡幾何？古人秉燭夜遊，良有以也。況陽春召我以煙景，大塊假我以文章。會桃李之芳園，序天倫之樂事。群季俊秀，皆為惠連；吾人詠歌，獨慚康樂。幽賞未已，高談轉清。開瓊筵以坐花，飛羽觴而醉月。不有佳詠，何伸雅懷？如詩不成，罰依金谷酒數。"
            ],
            "下載": []
        },
        {
            "key": 3,
            "曲目": "三",
            "詩名": "滕王閣序",
            "作者": "唐 王勃",
            "內容": [
                "披繡闥，俯雕甍，山原曠其盈視，川澤盱其駭矚。閭閻撲地，鐘鳴鼎食之家；舸艦迷津，青雀黃龍之舳。虹銷雨霽，彩徹雲衢。落霞與孤鶩齊飛，秋水共長天一色。漁舟唱晚，響窮彭蠡之濱，雁陣驚寒，聲斷衡陽之浦。遙吟俯暢，逸興遄飛。爽籟發而清風生，纖歌凝而白雲遏。睢園綠竹，氣凌彭澤之樽；鄴水朱華，光照臨川之筆。"
            ],
            "下載": []
        },
        {
            "key": 4,
            "曲目": "四",
            "詩名": "送孟東野序",
            "作者": "唐 韓愈",
            "內容": [
                "大凡物不得其平則鳴。草木之無聲，風撓之鳴。水之無聲，風蕩之鳴。其躍也，或激之；其趨也，或梗之；其沸也，或炙之。金石之無聲，或擊之鳴。人之於言也亦然，有不得已者而後言，其歌也有思，其哭也有懷。凡出乎口而爲聲者，其皆有弗平者乎？"
            ],
            "下載": []
        },
        {
            "key": 5,
            "曲目": "五",
            "詩名": "荔枝圖序",
            "作者": "唐 白居易",
            "內容": [
                "荔枝生巴峽間，樹形團團如帷蓋。葉如桂，冬青；華如橘，春榮；實如丹，夏熟；朵如葡萄；核如枇杷；殼如紅繒；膜如紫綃；瓤肉瑩白如冰雪；漿液甘酸如醴酪。大略如彼，其實過之。若離本枝，一日而色變，二日而香變，三日而味變，四五日外，色香味盡去矣。"
            ],
            "下載": []
        },
        {
            "key": 6,
            "曲目": "六",
            "詩名": "水滸傳序",
            "作者": "清 金聖嘆",
            "內容": [
                "快意之事莫若友，快友之快莫若談，其誰曰不然？然亦何曾多得。有時風寒，有時泥雨，有時臥病，有時不值，如是等時，真住牢獄矣。舍下薄田不多，多種秫米，身不能飲，吾友來需飲也。舍下門臨大河，嘉樹有蔭，為吾友行立蹲坐處也。"
            ],
            "下載": []
        }
    ],
    "傳狀": [
        {
            "key": 1,
            "曲目": "一",
            "詩名": "種樹郭橐駝傳",
            "作者": "唐 柳宗元",
            "內容": [
                "橐駝非能使木壽且孳也，能順木之天，以致其性焉爾。",
                "凡植木之性，其本欲舒，其培欲平，其土欲故，其築欲密。",
                "既然已，勿動勿慮，去不復顧。其蒔也若子，其置也若棄，則其天者全，而其性得矣。",
                "故吾不害其長而已，非有能碩茂之也；不抑耗其實而已，非有能蚤而蕃之也。"
            ],
            "下載": []
        },
        {
            "key": 2,
            "曲目": "二",
            "詩名": "蝜蝂傳",
            "作者": "唐 柳宗元",
            "內容": [
                "蝜蝂者，善負小蟲也。行，遇物輒持取，卬其首負之。背愈重，雖困劇不止也。",
                "其背甚澀，物積因不散，卒躓仆，不能起。人或憐之，爲去其負。苟能行，又持取如故。",
                "又好上高，極其力不已，至墜地死。今世之嗜取者，遇貨不避，以厚其室，不知爲己累也，唯恐其不積；",
                "及其怠而躓也，黜棄之，遷徙之，亦以病矣。苟能起，又不艾，日思高其位，大其祿，而貪取滋甚，以近於危墜。",
                "觀前之死亡不知戒，雖其形魁然大者也，其名人也，而智則小蟲也。亦足哀夫！"
            ],
            "下載": []
        },
        {
            "key": 3,
            "曲目": "三",
            "詩名": "管晏列傳",
            "作者": "西漢 司馬遷",
            "內容": [
                "吾始困時，嘗與鮑叔賈，分財利多自與，鮑叔不以我為貪，知我貧也。",
                "吾嘗為鮑叔謀事而更窮困，鮑叔不以我為愚，知時有利不利也。",
                "吾嘗三仕三見逐于君，鮑叔不以我為不肖，知我不遇時。",
                "吾嘗三戰三走，鮑叔不以我怯，知我有老母也。",
                "公子糾敗，召忽死之，吾幽囚受辱，鮑叔不以我為無恥，知我不羞小節，而恥功名不顯于天下也。",
                "生我者父母，知我者鮑子也！"
            ],
            "下載": []
        }
    ],
    "奏議": [
        {
            "key": 1,
            "曲目": "一",
            "詩名": "諫逐客書",
            "作者": "戰國 李斯",
            "內容": [
                "臣聞地廣者粟多，國大者人眾，兵彊則士勇。",
                "是以泰山不讓土壤，故能成其大；河海不擇細流，故能就其深；",
                "王者不卻眾庶，故能明其德。是以地無四方，民無異國，",
                "四時充美，鬼神降福，此五帝、三王之所以無敵也。",
                "今乃棄黔首以資敵國，卻賓客以業諸侯，",
                "使天下之士退而不敢西向，裹足不入秦，此所謂「藉寇兵而齎盜糧」者也。"
            ],
            "下載": []
        },
        {
            "key": 2,
            "曲目": "二",
            "詩名": "出師表",
            "作者": "三國 諸葛亮",
            "內容": [
                "臣本布衣，躬耕於南陽，苟全性命於亂世，不求聞達於諸侯。",
                "先帝不以臣卑鄙，猥自枉屈，三顧臣於草廬之中，諮臣以當世之事，",
                "由是感激，遂許先帝以驅馳。後值傾覆，受任於敗軍之際，奉命於危難之間：",
                "爾來二十有一年矣。先帝知臣謹慎，故臨崩寄臣以大事也。"
            ],
            "下載": []
        },
        {
            "key": 3,
            "曲目": "三",
            "詩名": "陳情表",
            "作者": "西晉 李密",
            "內容": [
                "臣以險釁，夙遭閔凶。生孩六月，慈父見背。行年四歲，舅奪母志。",
                "祖母劉愍臣孤弱，躬親撫養。臣少多疾病九歲不行；零丁孤苦，至於成立。",
                "既無叔伯，終鮮兄弟；門衰祚薄，晚有兒息。外無期功彊近之親，內無應門五尺之僮；",
                "煢煢獨立，形影相弔。而劉夙嬰疾病，常在床蓐；臣侍湯藥，未嘗廢離。"
            ],
            "下載": []
        }
    ],
    "書說": [
        {
            "key": 1,
            "曲目": "一",
            "詩名": "報任安書",
            "作者": "西漢 司馬遷",
            "內容": [
                "古者富貴而名磨滅，不可勝記，唯倜儻非常之人稱焉。蓋文王拘而演《周易》；仲尼厄而作《春秋》；屈原放逐，乃賦《離騷》；左丘失明，厥有《國語》；孫子臏腳，《兵法》修列；不韋遷蜀，世傳《呂覽》；韓非囚秦，《說難》《孤憤》；《詩》三百篇，大底聖賢發憤之所爲作也。此人皆意有所鬱結，不得通其道，故述往事、思來者。乃如左丘無目，孫子斷足，終不可用，退而論書策以舒其憤，思垂空文以自見。"
            ],
            "下載": []
        },
        {
            "key": 2,
            "曲目": "二",
            "詩名": "答謝中書書",
            "作者": "南朝 陶弘景",
            "內容": [
                "山川之美，古來共談。高峯入雲，清流見底。兩岸石壁，五色交輝。青林翠竹，四時俱備。曉霧將歇，猿鳥亂鳴；夕日欲頹，沉鱗競躍，實是欲界之仙都，自康樂以來，未復有能與其奇者。"
            ],
            "下載": []
        },
        {
            "key": 3,
            "曲目": "三",
            "詩名": "師說",
            "作者": "唐 韓愈",
            "內容": [
                "古之學者必有師。師者，所以傳道、受業、解惑也。人非生而知之者，孰能無惑？惑而不從師，其為惑也終不解矣！生乎吾前，其聞道也，固先乎吾，吾從而師之；生乎吾後，其聞道也，亦先乎吾，吾從而師之。吾師道也，夫庸知其年之先後生於吾乎？是故無貴、無賤、無長、無少，道之所存，師之所存也。"
            ],
            "下載": []
        },
        {
            "key": 4,
            "曲目": "四",
            "詩名": "進學解",
            "作者": "唐 韓愈",
            "內容": [
                "業精於勤，荒於嬉；行成於思，毀於隨。方今聖賢相逢，治具畢張。拔去凶邪，登崇畯良。占小善者率以錄，名一藝者無不庸。爬羅剔抉，刮垢磨光。蓋有幸而獲選，孰云多而不揚？諸生業患不能精，無患有司之不明；行患不能成，無患有司之不公。"
            ],
            "下載": []
        },
        {
            "key": 5,
            "曲目": "五",
            "詩名": "馬說",
            "作者": "唐 韓愈",
            "內容": [
                "世有伯樂，然後有千里馬。千里馬常有，而伯樂不常有。故雖有名馬，秖辱於奴隸人之手，駢死於槽櫪之間，不以千里稱也。馬之千里者，一食或盡粟一石；食馬者，不知其能千里而食也。是馬也，雖有千里之能，食不飽，力不足，才美不外見，且欲與常馬等不可得，安求其能千里也？策之不以其道，食之不能盡其材，鳴之而不能通其意，執策而臨之，曰：「天下無馬！」嗚呼！其真無馬邪？其真不知馬也！"
            ],
            "下載": []
        },
        {
            "key": 6,
            "曲目": "六",
            "詩名": "愛蓮說",
            "作者": "北宋 周敦頤",
            "內容": [
                "水陸草木之花，可愛者甚蕃。晉陶淵明獨愛菊。自李唐來，世人盛愛牡丹。予獨愛蓮之出淤泥而不染，濯清漣而不妖，中通外直，不蔓不枝，香遠益清，亭亭淨植，可遠觀而不可褻玩焉。予謂菊，花之隱逸者也；牡丹，花之富貴者也；蓮，花之君子者也。噫！菊之愛，陶後鮮有聞。蓮之愛，同予者何人？牡丹之愛，宜乎衆矣！"
            ],
            "下載": []
        },
        {
            "key": 7,
            "曲目": "七",
            "詩名": "訓儉示康",
            "作者": "北宋 司馬光",
            "內容": [
                "吾本寒家，世以清白相承。吾性不喜華靡，自為乳兒，長者加以金銀華美之服，輒羞赧棄去之。二十忝科名，聞喜宴獨不戴花。同年曰：「君賜不可違也。」乃簪一花。平生衣取蔽寒，食取充腹；亦不敢服垢弊以矯俗干名，但順吾性而已。眾人皆以奢靡為榮，吾心獨以儉素為美。"
            ],
            "下載": []
        },
        {
            "key": 8,
            "曲目": "八",
            "詩名": "猿說",
            "作者": "明 宋濂",
            "內容": [
                "武平產猿，猿毛若金絲，閃閃可觀；猿子尤奇，性可馴，然不離母。母黠，不可致。獵人以毒傅矢，伺母間射之，母度不能生，灑乳於林飲子；灑已，氣絕。獵人取母皮向子鞭之，子即悲鳴而下，斂手就制，每夕必寢皮乃安。甚者，輒抱皮跳擲而斃。嗟夫！猿且知有母，不愛其死。況人也耶？"
            ],
            "下載": []
        },
        {
            "key": 9,
            "曲目": "九",
            "詩名": "指喻",
            "作者": "明代 方孝孺",
            "內容": [
                "天下之事，常發於至微，而終為大患；始以為不足治，而終至於不可為。當其易也，惜旦夕之力，忽之而不顧；及其既成也，積歲月，疲思慮，而僅克之，如此指者多矣。蓋眾人之所可知者，眾人之所能治也，其勢雖危，而未足深畏；惟萌於不必憂之地，而寓於不可見之初，眾人笑而忽之者，此則君子之所深畏也 。"
            ],
            "下載": []
        },
        {
            "key": 10,
            "曲目": "十",
            "詩名": "與友人書",
            "作者": "清 顧炎武",
            "內容": [
                "人之為學，不日進則日退。獨學無友，則孤陋而難成；久處一方，則習染而不自覺。不幸而在窮僻之域，無車馬之資，猶當博學審問，古人與稽，以求其是非之所在，庶幾可得十之五六。若既不出戶，又不讀書，則是面牆之士，雖有子羔、原憲之賢，終無濟於天下。 子曰：「十室之邑，必有忠信如丘者焉，不如丘之好學也。」夫以孔子之聖，猶須好學，今人可不勉乎？"
            ],
            "下載": []
        }
    ],
    "雜記": [
        {
            "key": 1,
            "曲目": "一",
            "詩名": "管晏列傳",
            "作者": "西漢 司馬遷",
            "內容": [
                "吾始困時，嘗與鮑叔賈，分財利多自與，鮑叔不以我為貪，知我貧也。吾嘗為鮑叔謀事而更窮困，鮑叔不以我為愚，知時有利不利也。吾嘗三仕三見逐于君，鮑叔不以我為不肖，知我不遇時。吾嘗三戰三走，鮑叔不以我怯，知我有老母也。公子糾敗，召忽死之，吾幽囚受辱，鮑叔不以我為無恥，知我不羞小節，而恥功名不顯于天下也。生我者父母，知我者鮑子也！"
            ],
            "下載": []
        },
        {
            "key": 2,
            "曲目": "二",
            "詩名": "種樹郭橐駝傳",
            "作者": "唐 柳宗元",
            "內容": [
                "橐駝非能使木壽且孳也，能順木之天，以致其性焉爾。凡植木之性，其本欲舒，其培欲平，其土欲故，其築欲密。既然已，勿動勿慮，去不復顧。其蒔也若子，其置也若棄，則其天者全，而其性得矣。故吾不害其長而已，非有能碩茂之也；不抑耗其實而已，非有能蚤而蕃之也。"
            ],
            "下載": []
        },
        {
            "key": 3,
            "曲目": "三",
            "詩名": "蝜蝂傳",
            "作者": "唐 柳宗元",
            "內容": [
                "蝜蝂者，善負小蟲也。行，遇物輒持取，卬其首負之。背愈重，雖困劇不止也。其背甚澀，物積因不散，卒躓仆，不能起。人或憐之，爲去其負。苟能行，又持取如故。又好上高，極其力不已，至墜地死。今世之嗜取者，遇貨不避，以厚其室，不知爲己累也，唯恐其不積；及其怠而躓也，黜棄之，遷徙之，亦以病矣。苟能起，又不艾，日思高其位，大其祿，而貪取滋甚，以近於危墜。觀前之死亡不知戒，雖其形魁然大者也，其名人也，而智則小蟲也。亦足哀夫！"
            ],
            "下載": []
        },
        {
            "key": 4,
            "曲目": "四",
            "詩名": "伯牙鼓琴",
            "作者": "戰國 列禦寇",
            "內容": [
                "伯牙善鼓琴，鍾子期善聽。伯牙鼓琴，志在高山。鍾子期曰：「善哉，峨峨兮若泰山！」志在流水，鍾子期曰：「善哉，洋洋兮若江河！」伯牙所念，鍾子期必得之。伯牙遊於泰山之陰，卒逢暴雨，止於岩下：心悲，乃援琴而鼓之。初為霖雨之操，更造崩山之音。曲每奏，鍾子期輒窮其趣。伯牙乃舍琴而嘆曰：「善哉，善哉，子之聽夫！志想象猶吾心也。吾於何逃聲哉？」"
            ],
            "下載": []
        },
        {
            "key": 5,
            "曲目": "五",
            "詩名": "桃花源記",
            "作者": "東晉 陶潛",
            "內容": [
                "晉太元中，武陵人，捕魚爲業。緣溪行，忘路之遠近。忽逢桃花林，夾岸數百步，中無雜樹，芳草鮮美，落英繽紛，漁人甚異之。復前行，欲窮其林。林盡水源，便得一山，山有小口，彷彿若有光。便舍船，從口入。初極狹，才通人。復行數十步，豁然開朗。土地平曠，屋舍儼然，有良田美池桑竹之屬。阡陌交通，雞犬相聞。其中往來種作，男女衣着，悉如外人。黃髮垂髫，並怡然自樂。見漁人，乃大驚，問所從來。"
            ],
            "下載": []
        },
        {
            "key": 6,
            "曲目": "六",
            "詩名": "歸去來辭",
            "作者": "東晉 陶潛",
            "內容": [
                "舟搖搖以輕颺，風飄飄而吹衣。問征夫以前路，恨晨光之晞微。乃瞻衡宇，載欣載奔。童僕歡迎，稚子候門。三徑就荒，松菊猶存。攜幼入室，有酒盈罇。引壺觴以自酌，眄庭柯以怡顏。倚南窗以寄傲，審容膝之易安。園日涉以成趣，門雖設而常關。策扶老以流憩，時矯首而遐觀。雲無心以出岫，鳥倦飛而知還。景翳翳以將入，撫孤松而盤桓。"
            ],
            "下載": []
        },
        {
            "key": 7,
            "曲目": "七",
            "詩名": "岳陽樓記",
            "作者": "北宋 范仲淹",
            "內容": [
                "嗟夫！予嘗求古仁人之心，或異二者之為，何哉？不以物喜，不以己悲。居廟堂之高，則憂其民；處江湖之遠，則憂其君。是進亦憂，退亦憂；然則何時而樂耶？其必曰：「先天下之憂而憂，後天下之樂而樂」乎！噫，微斯人，吾誰與歸！"
            ],
            "下載": []
        },
        {
            "key": 8,
            "曲目": "八",
            "詩名": "醉翁亭記",
            "作者": "北宋 歐陽修",
            "內容": [
                "環滁皆山也。其西南諸峯，林壑尤美，望之蔚然而深秀者，琅邪也。山行六七里，漸聞水聲潺潺，而瀉出于兩峯之間者，釀泉也。峰回路轉，有亭翼然，臨于泉上者，醉翁亭也。作亭者誰？山之僧曰智僊也。名之者誰？太守自謂也。太守與客來飲于此，飲少輒醉，而年又最高，故自號曰醉翁也。醉翁之意不在酒，在乎山水之間也。山水之樂，得之心而寓之酒也。"
            ],
            "下載": []
        },
        {
            "key": 9,
            "曲目": "九",
            "詩名": "豐樂亭記",
            "作者": "北宋 歐陽脩",
            "內容": [
                "脩之來此，樂其地僻而事簡，又愛其俗之安閒。既得斯泉于山谷之間，乃日與滁人仰而望山，俯而聽泉。掇幽芳而蔭喬木，風霜冰雪，刻露清秀，四時之景，無不可愛。又幸其民樂其歲物之豐成，而喜與予遊也。因爲本其山川，道其風俗之美，使民知所以安此豐年之樂者，幸生無事之時也。"
            ],
            "下載": []
        },
        {
            "key": 10,
            "曲目": "十",
            "詩名": "墨池記",
            "作者": "北宋 曾鞏",
            "內容": [
                "臨川之城東，有地隱然而高，以臨於溪，曰新城。新城之上，有池窪然而方以長，曰「王羲之之墨池」者，荀伯子《臨川記》云也。羲之嘗慕張芝，臨池學書，池水盡黑，此爲其故跡，豈信然邪？方羲之之不可強以仕，而嘗極東方，出滄海，以娛其意于山水之間，豈其徜徉肆恣，而又嘗自休於此邪？羲之之書，晚乃善，則其所能，蓋亦以精力自致者，非天成也。然後世未有能及者，豈其學不如彼邪？則學固豈可以少哉！況欲深造道德者邪？"
            ],
            "下載": []
        },
        {
            "key": 11,
            "曲目": "十一",
            "詩名": "遊褒禪山記",
            "作者": "北宋 王安石",
            "內容": [
                "古人之觀於天地、山川、草木、蟲魚、鳥獸，往往有得，以其求思之深而無不在也。",
                "夫夷以近，則遊者衆；險以遠，則至者少。而世之奇偉、瑰怪，非常之觀，常在於險遠，而人之所罕至焉，故非有志者，不能至也。有志矣，不隨以止也，然力不足者，亦不能至也。",
                "有志與力，而又不隨以怠，至於幽暗昏惑，而無物以相之，亦不能至也。然力足以至焉，於人爲可譏，而在己爲有悔；盡吾志也，而不能至者，可以無悔矣，其孰能譏之乎？"
            ],
            "下載": []
        },
        {
            "key": 12,
            "曲目": "十二",
            "詩名": "記承天寺夜遊",
            "作者": "北宋 蘇軾",
            "內容": [
                "元豐六年十月十二日夜，解衣欲睡，月色入戶，欣然起行。念無與爲樂者，遂至承天寺尋張懷民。懷民亦未寢，相與步於中庭。",
                "庭下如積水空明，水中藻、荇交橫，蓋竹柏影也。何夜無月？何處無竹柏？但少閒人如吾兩人者耳。"
            ],
            "下載": []
        },
        {
            "key": 13,
            "曲目": "十三",
            "詩名": "黃州快哉亭記",
            "作者": "北宋 蘇轍",
            "內容": [
                "蓋亭之所見，南北百里，東西一合，濤瀾洶湧，風雲開闔；晝則舟楫出沒於其前，夜則魚龍悲嘯於其下；變化倏忽，動心駭目，不可久視。",
                "今乃得玩之几席之上，舉目而足；西望武昌諸山，岡陵起伏，草木行列，煙消日出，漁夫樵夫之舍，皆可指數，此其所以為「快哉」者也。",
                "至於長州之濱，故城之墟，曹孟德、孫仲謀之所睥睨，周瑜、陸遜之所馳騖，其流風遺跡，亦足以稱快世俗。"
            ],
            "下載": []
        },
        {
            "key": 14,
            "曲目": "十四",
            "詩名": "東軒記",
            "作者": "北宋 蘇轍",
            "內容": [
                "余昔少年讀書，竊嘗怪顏子以簞食瓢飲，居於陋巷，人不堪其憂，顏子不改其樂。",
                "私以為雖不欲仕，然抱關擊柝尚可自養，不害於學，何至困辱貧窶自苦如此？及來筠州，勤勞鹽米之間，無一日之休，雖欲棄塵垢，解羈縶，自放於道德之場，而事每劫而留之。然後知顏子之所以甘心貧賤，不肯求斗升之祿以自給者，良以其害於學故也。"
            ],
            "下載": []
        },
        {
            "key": 15,
            "曲目": "十五",
            "詩名": "觀潮",
            "作者": "南宋 周密",
            "內容": [
                "浙江之潮，天下之偉觀也。自既望以至十八日爲盛。方其遠出海門，僅如銀線，既而漸近，則玉城雪嶺，際天而來，大聲如雷霆，震撼激射，吞天沃日，勢極雄豪。",
                "楊誠齋詩云「海涌銀爲郭，江橫玉繫腰」者是也。每歲京尹出浙江亭教閱水軍，艨艟數百，分列兩岸，既而盡奔騰分合五陣之勢，並有乘騎弄旗標槍舞刀於水面者，如履平地。倏爾黃煙四起，人物略不相睹，水爆轟震，聲如崩山。煙消波靜，則一舸無跡，僅有敵船爲火所焚，隨波而逝。"
            ],
            "下載": []
        },
        {
            "key": 16,
            "曲目": "十六",
            "詩名": "項脊軒志",
            "作者": "明 歸有光",
            "內容": [
                "項脊軒，舊南閣子也。室僅方丈，可容一人居。百年老屋，塵泥滲漉，雨澤下注；每移案，顧視，無可置者。又北向，不能得日，日過午已昏。余稍爲修葺，使不上漏。前闢四窗，垣牆周庭，以當南日，日影反照，室始洞然。又雜植蘭桂竹木於庭，舊時欄楯，亦遂增勝。借書滿架，偃仰嘯歌，冥然兀坐，萬籟有聲。而庭階寂寂，小鳥時來啄食，人至不去。三五之夜，明月半牆，桂影斑駁，風移影動，珊珊可愛。"
            ],
            "下載": []
        },
        {
            "key": 17,
            "曲目": "十七",
            "詩名": "湖心亭看雪",
            "作者": "明 張岱",
            "內容": [
                "崇禎五年十二月，余住西湖。大雪三日，湖中人鳥聲俱絕。是日更定矣，余拏一小舟，擁毳衣爐火，獨往湖心亭看雪。霧凇沆碭，天與雲與山與水，上下一白。湖上影子，惟長堤一痕、湖心亭一點、與余舟一芥、舟中人兩三粒而已。"
            ],
            "下載": []
        },
        {
            "key": 18,
            "曲目": "十八",
            "詩名": "晚遊六橋待月記",
            "作者": "明 袁宏道",
            "內容": [
                "西湖最盛，為春，為月。一日之盛，為朝煙，為夕嵐。今歲春雪甚盛，梅花為寒所勒，與杏桃相次開發，尤為奇觀。石簀數為余言：「傅金吾園中梅，張功甫玉照堂故物也，急往觀之。」余時為桃花所戀，竟不忍去湖上。由斷橋至蘇堤一帶，綠煙紅霧，彌漫二十餘里。歌吹為風，粉汗為雨，羅紈之盛，多於堤畔之草，豔冶極矣。"
            ],
            "下載": []
        },
        {
            "key": 19,
            "曲目": "十九",
            "詩名": "斷橋",
            "作者": "明 張京元",
            "內容": [
                "西湖之勝在近，湖之易窮亦在近。朝車暮舫，徒行緩步，人人可遊，時時可遊，而酒多於水，肉高於山。春時肩摩趾錯，男女雜沓，以挨簇為樂。無論意不在山水，即桃容柳眼，自與東風相倚，遊者何曾一著眸子也。",
                "請依照這個格式產生json"
            ],
            "下載": []
        },
        {
            "key": 20,
            "曲目": "二十",
            "詩名": "望玉山記",
            "作者": "清 陳夢林",
            "內容": [
                "臘月既望，館人奔告玉山見矣。時旁午，風靜無塵，四宇清澈，日與山射，晶瑩耀目，如雪、如冰、如飛瀑、如舖練、如截肪。顧昔之命名者，弗取玉韞於石，生而素質，美在其中而光輝發越於外耶？臺北少石，獨萃茲山，山海之精，醞釀而象玉，不欲使人狎而玩之，宜於韜光而自匿也。山莊嚴瑰偉，三峰並列，大可盡護邑後諸山，而高出乎其半。"
            ],
            "下載": []
        },
        {
            "key": 21,
            "曲目": "二十一",
            "詩名": "遊江",
            "作者": "清 鄭燮",
            "內容": [
                "昨遊江上，見修竹數千株，其中有茅屋，有棋聲，有茶煙飄揚而出，心竊樂之。次日過訪其家，見琴書几席，淨好無塵，作一片豆綠色，蓋竹光相射故也。靜坐許久，從竹縫中向外而窺，見青山大江，風帆漁艇，又有葦洲，有耕犁，有饁婦，有二小兒戲於沙上，犬立岸傍，如相守者，直是小李將軍畫意，懸掛於竹枝竹葉間也。"
            ],
            "下載": []
        },
        {
            "key": 22,
            "曲目": "二十二",
            "詩名": "兒時記趣",
            "作者": "清 沈復",
            "內容": [
                "余憶童稚時，能張目對日，明察秋毫。見藐小微物，必細察其紋理，故時有物外之趣。夏蚊成雷，私擬作群鶴舞空，心之所向，則或千或百，果然鶴也；昂首觀之，項為之強。又留蚊於素帳中，徐噴以煙，使之沖煙飛鳴，作青雲白鶴觀；果如鶴唳雲端，為之怡然稱快。又常於土牆凹凸處、花臺小草叢雜處，蹲其身，使與臺齊；定神細視，以叢草為林，蟲蟻為獸；以土礫凸者為丘，凹者為壑，神遊其中，怡然自得。一日，見二蟲鬥草間，觀之，興正濃，忽有龐然大物，拔山倒樹而來，蓋一癩蝦蟆也。舌一吐而二蟲盡為所吞。余年幼，方出神，不覺呀然驚恐。神定，捉蝦蟆，鞭數十，驅之別院。"
            ],
            "下載": []
        },
        {
            "key": 23,
            "曲目": "二十三",
            "詩名": "鷗堂日記",
            "作者": "清 周星譽",
            "內容": [
                "五月二十五日丙戌，小暑，晴。申刻北風甚大，遂雨，有雷，傍晚霽，同寄公、 季貺出門看荷花。行田埂上，雨後泥濘，失足落水中，雙踝皆沒，不覺自笑，從種花人 周姓乞花三枝、蓮蓬一枝。歸，洗足早睡。鄉人種藕，以不花為豐年，蓋藕力盡泄於 花，花愈多則藕愈瘦。今田中彌望如雪，為我曹吟賞計甚得矣，鄉人得無怨乎？"
            ],
            "下載": []
        }
    ],
    "箴銘": [
        {
            "key": 1,
            "曲目": "一",
            "詩名": "陋室銘",
            "作者": "唐 劉禹錫",
            "內容": [
                "山不在高，有仙則名；水不在深，有龍則靈。斯是陋室，惟吾德馨。苔痕上階綠，草色入簾青。談笑有鴻儒，往來無白丁。可以調素琴，閱金經；無絲竹之亂耳，無案牘之勞形。南陽諸葛廬，西蜀子雲亭。孔子云：「何陋之有？」"
            ],
            "下載": []
        }
    ],
    "辭賦": [
        {
            "key": 1,
            "曲目": "一",
            "詩名": "秋聲賦",
            "作者": "北宋 歐陽脩",
            "內容": [
                "蓋夫秋之爲狀也，其色慘淡，煙霏雲斂；其容清明，天高日晶；其氣慄冽，砭人肌骨；其意蕭條，山川寂寥。故其爲聲也，淒淒切切，呼號憤發。豐草綠縟而爭茂，佳木蔥蘢而可悅；草拂之而色變，木遭之而葉脫；其所以摧敗零落者，乃其一氣之餘烈。夫秋，刑官也，於時爲陰；又兵象也，於行用金；是謂天地之義氣，常以肅殺而爲心。"
            ],
            "下載": []
        },
        {
            "key": 2,
            "曲目": "二",
            "詩名": "前赤壁賦",
            "作者": "北宋 蘇軾",
            "內容": [
                "客亦知夫水與月乎？逝者如斯，而未嘗往也；盈虛者如彼，而卒莫消長也。蓋將自其變者而觀之，則天地曾不能以一瞬；自其不變者而觀之，則物與我皆無盡也，而又何羨乎！且夫天地之間，物各有主，苟非吾之所有，雖一毫而莫取。惟江上之清風，與山間之明月，耳得之而為聲，目遇之而成色，取之無禁，用之不竭。是造物者之無盡藏也，而吾與子之所共適。"
            ],
            "下載": []
        }
    ]
}
const Poems4 = {
    "上卷・上平聲韻母": [
        {
            "key": 1,
            "曲目": "一",
            "詩名": "一東",
            "作者": "",
            "內容": [
                '雲對雨，雪對風，晚照對晴空。',
                '來鴻對去燕，宿鳥對鳴蟲。',
                '三尺劍，六鈞弓，嶺北對江東。',
                '人間清暑殿，天上廣寒宮。',
                '夾岸曉煙楊柳綠，滿園春雨杏花紅。',
                '兩鬢風霜，途次早行之客',
                '一蓑煙雨，溪邊晚釣之翁。',
                '沿對革，異對同，白叟對黃童。',
                '江風對海霧，牧子對漁翁。',
                '顏巷陋，阮途窮， 冀北對遼東。',
                '池中濯足水，門外打頭風。',
                '梁帝講經同泰寺，漢皇置酒未央宮。',
                '塵慮縈心，懶 撫七弦綠綺;',
                '霜華滿鬢，羞看百鍊青銅。',
                '貧對富，塞對通，野叟對溪童。',
                '鬢皤對眉綠，齒皓對唇紅。',
                '天浩浩，日融融，佩劍對彎弓。',
                '半溪流水綠， 千樹落花紅。',
                '野渡燕穿楊柳雨，芳池魚戲芰荷風。',
                '女子眉纖，額下現一彎新月;',
                '男兒氣壯，胸中吐萬丈長虹。',
            ],
            "下載": []
        },
        {
            "key": 2,
            "曲目": "二",
            "詩名": "二冬",
            "作者": "",
            "內容": [
                '春對夏，秋對冬，暮鼓對晨鐘。觀山對玩水，綠竹對蒼松。',
                '馮婦虎，葉公龍，舞蝶對鳴蛩。銜泥雙紫燕，課蜜幾黃蜂。',
                '春日園中鶯恰恰，秋天塞外雁雝雝。秦嶺雲橫，迢遞八千遠路；',
                '巫山雨洗，嵯峨十二危峰。',
                '明對暗，淡對濃，上智對中庸。鏡奩對衣笥，野杵對村舂。',
                '花灼爍，草蒙茸，九夏對三冬。臺高名戲馬，齋小號蟠龍。',
                '手擘蟹螯從畢卓，身披鶴氅自王恭。五老峰高，秀插雲霄如玉筆；',
                '三姑石大，響傳風雨若金鏞。',
                '仁對義，讓對恭，禹舜對羲農。雪花對雲葉，芍藥對芙蓉。',
                '陳後主，漢中宗，繡虎對雕龍。柳塘風淡淡，花圃月濃濃。',
                '春日正宜朝看蝶，秋風那更夜聞蛩。戰士邀功，必藉干戈成勇武；',
                '逸民適志，須憑詩酒養疏慵。'
            ],
            "下載": []
        },
        {
            "key": 3,
            "曲目": "三",
            "詩名": "三江",
            "作者": "",
            "內容": [
                '樓對閣，戶對窗，巨海對長江。蓉裳對蕙帳，玉斝對銀釭。',
                '青布幔，碧油幢，寶劍對金缸。忠心安社稷，利口覆家邦。',
                '世祖中興延馬武，桀王失道殺龍逄。秋雨瀟瀟，爛漫黃花都滿徑；',
                '春風裊裊，扶疏綠竹正盈窗。',
                '旌對旆，蓋對幢，故國對他邦。千山對萬水，九澤對三江。',
                '山岌岌，水淙淙，鼓振對鍾撞。清風生酒舍，皓月照書窗。',
                '陣上倒戈辛紂戰，道旁繫劍子嬰降。夏日池塘，出沒浴波鷗對對；',
                '春風簾幕，往來營壘燕雙雙。',
                '銖對兩，隻對雙，華嶽對湘江。朝車對禁鼓，宿火對寒缸。',
                '青瑣闥，碧紗窗，漢社對周邦。笙簫鳴細細，鐘鼓響摐摐。',
                '主簿棲鸞名有覽，治中展驥姓惟龐。蘇武牧羊，雪屢餐於北海；',
                "莊周活鮒，水必決於西江。"
            ],
            "下載": []
        },
        {
            "key": 4,
            "曲目": "四",
            "詩名": "四支",
            "作者": "",
            "內容": [
                '茶對酒，賦對詩，燕子對鶯兒。栽花對種竹，落絮對遊絲。',
                '四目頡，一足夔，鴝鵒對鷺鷥。半池紅菡萏，一架白荼蘼。',
                '幾陣秋風能應候，一犁春雨甚知時。智伯恩深，國士吞變形之炭；',
                '羊公德大，邑人豎墮淚之碑。',
                '行對止，速對遲，舞劍對圍棋。花箋對草字，竹簡對毛錐。',
                '汾水鼎，峴山碑，虎豹對熊羆。花開紅錦繡，水漾碧琉璃。',
                '去婦因探鄰舍棗，出妻為種後園葵。笛韻和諧，仙管恰從雲裡降；',
                '櫓聲咿軋，漁舟正向雪中移。',
                '戈對甲，鼓對旗，紫燕對黃鸝。梅酸對李苦，青眼對白眉。',
                '三弄笛，一圍棋，雨打對風吹。海棠春睡早，楊柳晝眠遲。',
                '張駿曾為槐樹賦，杜陵不作海棠詩。晉士特奇，可比一斑之豹；',
                '唐儒博識，堪為五總之龜。'
            ],
            "下載": []
        },
        {
            "key": 5,
            "曲目": "五",
            "詩名": "五微",
            "作者": "",
            "內容": [
                '來對往，密對稀，燕舞對鶯飛。風清對月朗，露重對煙微。',
                '霜菊瘦，雨梅肥，客路對漁磯。晚霞舒錦繡，朝露綴珠璣。',
                '夏暑客思欹石枕，秋寒婦念寄邊衣。春水才深，青草岸邊漁父去；',
                '夕陽半落，綠莎原上牧童歸。',
                '寬對猛，是對非，服美對乘肥。珊瑚對玳瑁，錦繡對珠璣。',
                '桃灼灼，柳依依，綠暗對紅稀。窗前鶯並語，簾外燕雙飛。',
                '漢致太平三尺劍，周臻大定一戎衣。吟成賞月之詩，只愁月墮；',
                '斟滿送春之酒，惟憾春歸。',
                '聲對色，飽對饑，虎節對龍旗。楊花對桂葉，白簡對朱衣。',
                '尨也吠，燕于飛，蕩蕩對巍巍。春暄資日氣，秋冷借霜威。',
                '出使振威馮奉世，治民異等尹翁歸。燕我弟兄，載詠棣棠韡韡；',
                '命伊將帥，為歌楊柳依依。'
            ],
            "下載": []
        },
        {
            "key": 6,
            "曲目": "六",
            "詩名": "六魚",
            "作者": "",
            "內容": [
                '無對有，實對虛，作賦對觀書。綠窗對朱戶，寶馬對香車。',
                '伯樂馬，浩然驢，弋雁對求魚。分金齊鮑叔，奉璧藺相如。',
                '擲地金聲孫綽賦，回文錦字竇滔書。未遇殷宗，胥靡困傅巖之築；',
                '既逢周后，太公舍渭水之漁。',
                '終對始，疾對徐，短褐對華裾。六朝對三國，天祿對石渠。',
                '千字策，八行書，有若對相如。花殘無戲蝶，藻密有潛魚。',
                '落葉舞風高復下，小荷浮水捲還舒。愛見人長，共服宣尼休假蓋；',
                '恐彰己吝，誰知阮裕竟焚車。',
                '麟對鳳，鱉對魚，內史對中書。犁鋤對耒耜，畎澮對郊墟。',
                '犀角帶，象牙梳，駟馬對安車。青衣能報赦，黃耳解傳書。',
                '庭畔有人持短劍，門前無客曳長裾。波浪拍船，駭舟人之水宿；',
                '峰巒繞舍，樂隱者之山居。'
            ],
            "下載": []
        },
        {
            "key": 7,
            "曲目": "七",
            "詩名": "七虞",
            "作者": "",
            "內容": [
                '金對玉，寶對珠，玉兔對金烏。孤舟對短棹，一雁對雙鳧。',
                '橫醉眼，捻吟鬚，李白對楊朱。秋霜多過雁，夜月有啼烏。',
                '日暖園林花易賞，雪寒村舍酒難沽。人處嶺南，善探巨象口中齒；',
                '客居江右，偶奪驪龍頷下珠。',
                '對聖，智對愚，傅粉對施朱。名韁對利鎖，挈榼對提壺。',
                '鳩哺子，燕調雛，石帳對郇廚。煙輕籠岸柳，風急撼庭梧。',
                '鴝眼一方端石硯，龍涎三炷博山壚。曲沼魚多，可使漁人結網；',
                '平田兔少，漫勞耕者守株。',
                '秦對趙，越對吳，釣客對耕夫。箕裘對杖履，杞梓對桑榆。',
                '天欲曉，日將晡，狡兔對妖狐。讀書甘刺股，煮粥惜焚鬚。',
                '韓信武能平四海，左思文足賦三都。嘉遁幽人，適志竹籬茅舍；',
                '勝游公子，玩情柳陌花衢。'
            ],
            "下載": []
        },
        {
            "key": 8,
            "曲目": "八",
            "詩名": "八齊",
            "作者": "",
            "內容": [
                '巖對岫，澗對溪，遠岸對危堤。鶴長對鳧短，水雁對山雞。',
                '星拱北，月流西，漢露對湯霓。桃林牛已放，虞阪馬長嘶。',
                '叔侄去官聞廣受，弟兄讓國有夷齊。三月春濃，芍藥叢中蝴蝶舞；',
                '五更天曉，海棠枝上子規啼。',
                '雲對雨，水對泥，白璧對玄圭。獻瓜對投李，禁鼓對征鼙。',
                '徐稚榻，魯班梯，鳳翥對鸞棲， 有官清似水，無客醉如泥。',
                '截髮惟聞陶侃母，斷機只有樂羊妻。秋望佳人，目送樓頭千里雁；',
                '早行遠客，夢驚枕上五更雞。',
                '熊對虎，象對犀，霹靂對虹霓。杜鵑對孔雀，桂嶺對梅溪。',
                '蕭史鳳，宋宗雞，遠近對高低。水寒魚不躍，林茂鳥頻棲。',
                '楊柳和煙彭澤令，桃花流水武陵溪。公子追歡，閒驟玉驄游綺陌；',
                '佳人倦繡，閣欹珊枕掩香閨。'
            ],
            "下載": []
        },
        {
            "key": 9,
            "曲目": "九",
            "詩名": "九佳",
            "作者": "",
            "內容": [
                '河對海，漢對淮，赤岸對朱崖。鷺飛對魚躍，寶鈿對金釵。',
                '魚圉圉，鳥喈喈，草履對芒鞋。古賢嘗篤厚，時輩喜詼諧。',
                '孟訓文公談性善，顏師孔子問心齋。緩撫琴弦，像流鶯而並語；',
                '斜排箏柱，類過雁之相挨。',
                '豐對儉，等對差，布襖對荊釵。雁行對魚陣，榆塞對蘭崖。',
                '挑薺女，採蓮娃，菊徑對苔階。詩成六義備，樂奏八音諧。',
                '造律吏哀秦法酷，知音人說鄭聲哇。天欲飛霜，塞上有鴻行已過；',
                '雲將作雨，庭前多蟻陣先排。',
                '城對市，巷對街，破屋對空階。桃枝對桂葉，砌蚓對牆蝸。',
                '梅可望，橘堪懷，季路對高柴。花藏沽酒市，竹映讀書齋。',
                '馬首不容孤竹扣，車輪終就洛陽埋。',
                '朝宰錦衣，貴束烏犀之帶；宮人寶髻，宜簪白燕之釵。'
            ],
            "下載": []
        },
        {
            "key": 10,
            "曲目": "十",
            "詩名": "十灰",
            "作者": "",
            "內容": [
                '增對損，閉對開，碧草對蒼苔。書籤對筆架，兩曜對三台。',
                '周召虎，宋桓魋，閬苑對蓬萊。薰風生殿閣，皓月照樓台。',
                '卻馬漢文思罷獻，吞蝗唐太冀移災。照耀八荒，赫赫麗天秋日；',
                '震驚百里，轟轟出地春雷。',
                '沙對水，火對灰，雨雪對風雷。書淫對傳癖，水滸對岩隈。',
                '歌舊曲，釀新醅，舞館對歌臺。春棠經雨放，秋菊傲霜開。',
                '作酒固難忘麴櫱，調羹必要用鹽梅。月滿庾樓，據胡床而可玩；',
                '花開唐苑，轟羯鼓以奚催。',
                '休對咎，福對災，象箸對犀杯。宮花對御柳，峻閣對高臺。',
                '花蓓蕾，草根荄，剔蘚對剜苔。雨前庭蟻鬧，霜後陣鴻哀。',
                '元亮南窗今日傲，孫弘東閣幾時開。平展青茵，野外茸茸軟草；',
                '高張翠幄，庭前鬱鬱涼槐。'

            ],
            "下載": []
        },
        {
            "key": 11,
            "曲目": "十一",
            "詩名": "十一真",
            "作者": "",
            "內容": [
                '邪對正，假對真，獬豸對麒麟。韓盧對蘇雁，陸橘對莊椿。',
                '韓五鬼，李三人，北魏對西秦。蟬鳴哀暮夏，鶯囀怨殘春。',
                '野燒焰騰紅爍爍，溪流波皺碧粼粼。行無蹤，居無廬，頌成酒德；',
                '動有時，藏有節，論著錢神。',
                '哀對樂，富對貧，好友對嘉賓。',
                '彈冠對結綬，白日對青春。',
                '金翡翠，玉麒麟，虎爪對龍麟。柳塘生細浪，花徑起香塵。',
                '閒愛登山穿謝屐，醉思漉酒脫陶巾。雪冷霜嚴，倚檻松筠同傲歲；',
                '日遲風暖，滿園花柳各爭春。',
                '香對火，炭對薪，日觀對天津。禪心對道眼，野婦對宮嬪。',
                '仁無敵，德有鄰，萬石對千鈞。滔滔三峽水，冉冉一溪冰。',
                '充國功名當畫閣，子張言行貴書紳。篤志詩書，思入聖賢絕域；',
                '忘情官爵，羞沾名利纖塵。'
            ],
            "下載": []
        },
        {
            "key": 12,
            "曲目": "十二",
            "詩名": "十二文",
            "作者": "",
            "內容": [
                '家對國，武對文，四輔對三軍。九經對三史，菊馥對蘭芬。',
                '歌北鄙，詠南薰，邇聽對遙聞。召公周太保，李廣漢將軍。',
                '聞化蜀民皆草偃，爭權晉土已瓜分。巫峽夜深，猿嘯苦哀巴地月；',
                '衡峰秋早，雁飛高貼楚天雲。',
                '欹對正，見對聞，偃武對修文。羊車對鶴駕，朝旭對晚曛。',
                '花有艷，竹成文，馬燧對羊欣。山中梁宰相，樹下漢將軍。',
                '施帳解圍嘉道韞，當壚沽酒嘆文君。好景有期，北嶺幾枝梅似雪；',
                '豐年先兆，西郊千頃稼如雲。',
                '堯對舜，夏對殷，蔡惠對劉蕡。山明對水秀，五典對三墳。',
                '唐李杜，晉機雲，事父對忠君。雨晴鳩喚婦，霜冷雁呼群。',
                '酒量洪深周僕射，詩才俊逸鮑參軍。鳥翼長隨，鳳兮洵眾禽長；',
                '狐威不假，虎也真百獸尊。'
            ],
            "下載": []
        },
        {
            "key": 13,
            "曲目": "十三",
            "詩名": "十三元",
            "作者": "",
            "內容": [
                '幽對顯，寂對喧，柳岸對桃源。鶯朋對燕友，早暮對寒暄。',
                '魚躍沼，鶴乘軒，醉膽對吟魂。輕塵生范甑，積雪擁袁門。',
                '縷縷輕煙芳草渡，絲絲微雨杏花村。詣闕王通，獻太平十二策；',
                '出關老子，著道德五千言。',
                '兒對女，子對孫，藥圃對花村。高樓對邃閣，赤豹對玄猿。',
                '妃子騎，夫人軒，曠野對平原。匏巴能鼓瑟，伯氏善吹壎。',
                '馥馥早梅思驛使，萋萋芳草怨王孫。秋夕月明，蘇子黃岡游赤壁；',
                '春朝花發，石家金谷啟芳園。',
                '歌對舞，德對恩，犬馬對雞豚。龍池對鳳沼，雨驟對雲屯。',
                '劉向閣，李膺門，唳鶴對啼猿。柳搖春白晝，梅弄月黃昏。',
                '歲冷松筠皆有節，春喧桃李本無言。噪晚齊蟬，歲歲秋來泣恨；',
                '啼宵蜀鳥，年年春去傷魂。'
            ],
            "下載": []
        },
        {
            "key": 14,
            "曲目": "十四",
            "詩名": "十四寒",
            "作者": "",
            "內容": [
                '多對少，易對難，虎踞對龍蟠。龍舟對鳳輦，白鶴對青鸞。',
                '風淅淅，露漙漙，繡轂對雕鞍。魚游荷葉沼，鷺立蓼花灘。',
                '有酒阮貂奚用解，無魚馮鋏必須彈。丁固夢松，柯葉忽然生腹上；',
                '文郎畫竹，枝梢倏爾長毫端。',
                '寒對暑，濕對乾，魯隱對齊桓。寒氈對暖席，夜飲對晨餐。',
                '叔子帶，仲由冠，郟鄏對邯鄲。嘉禾憂夏旱，衰柳耐秋寒。',
                '楊柳綠遮元亮宅，杏花紅映仲尼壇。江水流長，環繞似青羅帶；',
                '海蟾輪滿，澄明如白玉盤。',
                '橫對豎，窄對寬，黑痣對彈丸。朱簾對畫棟，彩檻對雕欄。',
                '春既老，夜將闌，百辟對千官。懷仁稱足足，抱義美般般。',
                '好馬君王曾市骨，食豬處士僅思肝。世仰雙仙，元禮舟中攜郭泰；',
                '人稱連壁，夏侯車上並潘安。'

            ],
            "下載": []
        },
        {
            "key": 15,
            "曲目": "十五",
            "詩名": "十五刪",
            "作者": "",
            "內容": [
                '興對廢，附對攀，露草對霜菅。歌廉對借寇，習孔對希顏。',
                '山壘壘，水潺潺，奉璧對探鐶。禮由公旦作，詩本仲尼刪。',
                '驢困客方經灞水，雞鳴人已出函關。幾夜霜飛，已有蒼鴻辭北塞；',
                '數朝霧暗，豈無玄豹隱南山。',
                '對尚，侈對慳，霧髻對煙鬟。鶯啼對鵲噪，獨鶴對雙鷳。',
                '黃牛峽，金馬山，結草對銜環。崑山惟玉集，合浦有珠還。',
                '阮籍舊能為眼白，老萊新愛著衣斑。棲遲避世人，草衣木食；',
                '窈窕傾城女，雲鬢花顏。',
                '姚對宋，柳對顏，賞善對懲奸。愁中對夢裡，巧慧對痴頑。',
                '孔北海，謝東山，使越對征蠻。淫聲聞濮上，離曲聽陽關。',
                '驍將袍披仁貴白，小兒衣著老萊斑。茅舍無人，難卻塵埃生榻上；',
                '竹亭有客，尚留風月在窗間。'
            ],
            "下載": []
        },
    ],
    "下卷・下平聲韻母": [
        {
            "key": 1,
            "曲目": "一",
            "詩名": "一先",
            "作者": "",
            "內容": [
                '晴對雨，地對天，天地對山川。山川對草木，赤壁對青田。',
                '郟鄏鼎，武城弦，木筆對苔錢。金城三月柳，玉井九秋蓮。',
                '何處春朝風景好，誰家秋夜月華圓。珠綴花梢，千點薔薇香露；',
                '練橫樹杪，幾絲楊柳殘煙。',
                '前對後，後對先，眾醜對孤妍。鶯簧對蝶板，虎穴對龍淵。',
                '擊石磬，觀韋編，鼠目對鳶肩。春園花柳地，秋沼芰荷天。',
                '白羽頻揮閒客坐，烏紗半墜醉翁眠。野店幾家，羊角風搖沽酒旆；',
                '長川一帶，鴨頭波泛賣魚船。',
                '離對坎，震對乾，一日對千年。堯天對舜日，蜀水對秦川。',
                '蘇武節，鄭虔氈，澗壑對林泉。揮戈能退日，持管莫窺天。',
                '寒食芳辰花爛熳，中秋佳節月嬋娟。夢裡榮華，飄忽枕中之客；',
                '壺中日月，安閒市上之仙。'

            ],
            "下載": []
        },
        {
            "key": 2,
            "曲目": "二",
            "詩名": "二蕭",
            "作者": "",
            "內容": [
                '恭對慢，吝對驕，水遠對山遙。松軒對竹檻，雪賦對風謠。',
                '乘五馬，貫雙鵰，燭滅對香消。明蟾常徹夜，驟雨不終朝。',
                '樓閣天涼風颯颯，關河地隔雨瀟瀟。幾點鷺鷥，日暮常飛紅蓼岸；',
                '一雙鸂鶒，春朝頻泛綠楊橋。',
                '開對落，暗對昭，趙瑟對虞韶。軺車對驛騎，錦繡對瓊瑤。',
                '羞攘臂，懶折腰，范甑對顏瓢。寒天鴛帳酒，夜月鳳台簫。',
                '舞女腰肢楊柳軟，佳人顏貌海棠嬌。豪客尋春，南陌草青香陣陣；',
                '閒人避暑，東堂蕉綠影搖搖。',
                '班對馬，董對晁，夏晝對春宵。雷聲對電影，麥穗對禾苗。',
                '八千路，廿四橋，總角對垂髫。露桃勻嫩臉，風柳舞纖腰。',
                '賈誼賦成傷鵩鳥，周公詩就托鴟鴞。幽寺尋僧，逸興豈知俄爾盡；',
                '長亭送客，離魂不覺黯然消。'
            ],
            "下載": []
        },
        {
            "key": 3,
            "曲目": "三",
            "詩名": "三肴",
            "作者": "",
            "內容": [
                '風對雅，象對爻，巨蟒對長蛟。天文對地理，蟋蟀對螵蛸。',
                '龍夭矯，虎咆哮，北學對東膠。築臺須壘土，成屋必誅茅。',
                '潘岳不忘秋興賦，邊韶常被晝眠嘲。撫養群黎，已見國家隆治；',
                '滋生萬物，方知天地泰交。',
                '蛇對虺，蜃對蛟，麟藪對鵲巢。風聲對月色，麥穗對桑苞。',
                '何妥難，子雲嘲，楚甸對商郊。五音惟耳聽，萬慮在心包。',
                '葛被湯征因仇餉，楚遭齊伐責包茅。高矣若天，洵是聖人大道；',
                '淡而如水，實為君子神交。',
                '牛對馬，犬對貓，旨酒對嘉肴。桃紅對柳綠，竹葉對松梢。',
                '藜杖叟，布衣樵，北野對東郊。白駒形皎皎，黃鳥語交交。',
                '花圃春殘無客到，柴門夜永有僧敲。牆畔佳人，飄揚競把鞦韆舞；',
                '樓前公子，笑語爭將蹴踘拋。'
            ],
            "下載": []
        },
        {
            "key": 4,
            "曲目": "四",
            "詩名": "四豪",
            "作者": "",
            "內容": [
                '琴對瑟，劍對刀，地迥對天高。峨冠對博帶，紫綬對緋袍。',
                '煎異茗，酌香醪，虎兕對猿猱。武夫攻騎射，野婦務蠶繅。',
                '秋雨一川淇澳竹，春風兩岸武陵桃。螺髻青濃，樓外晚山千仞；',
                '鴨頭綠膩，溪中春水半篙。',
                '刑對賞，貶對褒，鉞斧對征袍。梧桐對橘柚，枳棘對蓬蒿。',
                '雷煥劍，呂虔刀，橄欖對葡萄。',
                '一椽書舍小，百尺酒樓高。',
                '李白能詩時秉筆，劉伶愛酒每餔糟。禮別尊卑，拱北眾星常燦燦；',
                '勢分高下，朝東萬水自滔滔。',
                '瓜對果，李對桃，犬子對羊羔。春分對夏至，谷水對山濤。',
                '雙鳳翼，九牛毛，主逸對臣勞。水流無限闊，山聳有餘高。',
                '雨打村童新牧笠，塵生邊將舊征袍。俊士居官，榮引鵷鴻之序；',
                '忠臣報國，誓殫犬馬之勞。'
            ],
            "下載": []
        },
        {
            "key": 5,
            "曲目": "五",
            "詩名": "五歌",
            "作者": "",
            "內容": [
                '山對水，海對河，雪竹對煙蘿。新歡對舊恨，痛飲對高歌。',
                '琴再撫，劍重磨，媚柳對枯荷。荷盤從雨洗，柳線任風搓。',
                '飲酒豈知欹醉帽，觀棋不覺爛樵柯。山寺清幽，直踞千層雲嶺；',
                '江樓宏敞，遙臨萬頃煙波。',
                '繁對簡，少對多，里詠對途歌。宦情對旅況，銀鹿對銅駝。',
                '刺史鴨，將軍鵝，玉律對金科。古堤垂老柳，曲沼長新荷。',
                '命駕呂因思叔夜，引車藺為避廉頗。千尺水簾，今古無人能手捲；',
                '一輪月鏡，乾坤何匠用功磨。',
                '霜對露，浪對波，徑菊對池荷。酒闌對歌罷，日暖對風和。',
                '梁父詠，楚狂歌，放鶴對觀鵝。史才推永叔，刀筆仰蕭何。',
                '種橘猶嫌千樹少，寄梅誰信一枝多。林下風生，黃髮村童攜牧笠；',
                '江頭日出，皓眉溪叟曬漁蓑。'
            ],
            "下載": []
        },
        {
            "key": 6,
            "曲目": "六",
            "詩名": "六麻",
            "作者": "",
            "內容": [
                '松對柏，縷對麻，蟻陣對蜂衙。鱗對白鷺，凍雀對昏鴉，',
                '白墮酒，碧沉茶，品笛對吹笳。秋涼梧墮葉，春暖杏開花。',
                '雨長苔痕侵壁砌，月移梅影上窗紗。颯颯秋風，度城頭之篳篥；',
                '遲遲晚照，動江上之琵琶。',
                '優對劣，凸對凹，翠竹對黃花。松杉對杞梓，菽麥對桑麻。',
                '山不斷，水無涯，煮酒對烹茶。魚游池面水，鷺立岸頭沙。',
                '百畝風翻陶令秫，一畦雨熟邵平瓜。閒捧竹根，飲李白一壺之酒；',
                '偶擎桐葉，啜盧仝七碗之茶。',
                '吳對楚，蜀對巴，落日對流霞。酒錢對詩債，梧葉對松花。',
                '馳驛騎，泛仙槎，碧玉對丹砂。設橋偏送筍，開道竟還瓜。',
                '楚國大夫沉汨水，洛陽才子謫長沙。書篋琴囊，乃士流活計；',
                '藥爐茶鼎，實閒客生涯。'
            ],
            "下載": []
        },
        {
            "key": 7,
            "曲目": "七",
            "詩名": "七陽",
            "作者": "",
            "內容": [
                '高對下，短對長，柳影對花香。詞人對賦客，五帝對三王。',
                '深院落，小池塘，晚眺對晨妝。絳霄唐帝殿，綠野晉公堂。',
                '寒集謝莊衣上雪，秋添潘岳鬢邊霜。人浴蘭湯，事不忘於端午；',
                '客斟菊酒，典常記於重陽。',
                '堯對舜，禹對湯，晉宋對隋唐。奇花對異卉，夏日對秋霜。',
                '八叉手，九迴腸，地久對天長。',
                '一堤楊柳綠，三徑菊花黃。',
                '聞鼓塞兵方戰鬥，聽鐘宮女正梳妝。春飲方歸，紗帽半淹鄰舍酒；',
                '早朝初退，袞衣微惹御爐香。',
                '荀對孟，老對莊，嚲柳對垂楊。仙宮對梵宇，小閣對長廊。',
                '風月窟，水雲鄉，蟋蟀對螳螂。暖煙香靄靄，寒燭影煌煌。',
                '伍子欲酬漁父劍，韓生嘗竊賈公香。三月韶光，常憶花明柳媚；',
                '一年好景，難忘橘綠橙黃。'
            ],
            "下載": []
        },
        {
            "key": 8,
            "曲目": "八",
            "詩名": "八庚",
            "作者": "",
            "內容": [
                '深對淺，重對輕，有影對無聲。蜂腰對蝶翅，宿醉對餘醒。',
                '天北缺，日東生，獨臥對同行。寒冰三尺厚，秋月十分明。',
                '萬卷書容閒客覽，一樽酒待故人傾。心侈唐玄，厭看霓裳之曲；',
                '意驕陳主，飽聞玉樹之賡。',
                '虛對實，送對迎，後甲對先庚。鼓琴對舍瑟，搏虎對騎鯨。',
                '金匼匝，玉瑽琤，玉宇對金莖。花間雙粉蝶，柳內幾黃鶯。',
                '貧裡每甘藜藿味，醉中厭聽管弦聲。腸斷秋閨，涼吹已侵重被冷；',
                '夢驚曉枕，殘蟾猶照半窗明。',
                '漁對獵，釣對耕，玉振對金聲。雉城對雁塞，柳裊對葵傾。',
                '吹玉笛，弄銀笙，阮杖對桓箏。墨呼松處士，紙號楮先生。',
                '露浥好花潘岳縣，風搓細柳亞夫營。撫動琴弦，遽覺座中風雨至；',
                '哦成詩句，應知窗外鬼神驚。'
            ],
            "下載": []
        },
        {
            "key": 9,
            "曲目": "九",
            "詩名": "九青",
            "作者": "",
            "內容": [
                '紅對紫，白對青，漁火對禪燈。唐詩對漢史，釋典對仙經。',
                '龜曳尾，鶴梳翎，月榭對風亭。',
                '一輪秋夜月，幾點曉天星。',
                '晉士只知山簡醉，楚人誰識屈原醒。倦繡佳人，慵把鴛鴦文作枕；',
                '吮毫畫者，思將孔雀寫為屏。',
                '行對坐，醉對醒，佩紫對紆青。棋枰對筆架，雨雪對雷霆。',
                '狂蛺蝶，小蜻蜓，水岸對沙汀。天台孫綽賦，劍閣孟陽銘。',
                '傳信子卿千里雁，照書車胤一囊螢。冉冉白雲，夜半高遮千里月；',
                '澄澄碧水，宵中寒映一天星。',
                '書對畫，傳對經，鸚鵡對鶺鴒。黃茅對白荻，綠草對青萍。',
                '風繞鐸，雨淋鈴，水閣對山亭。渚蓮千朵白，岸柳兩行青。',
                '漢代宮中生秀柞，堯時階畔長祥蓂。',
                '一枰決勝，棋子分黑白；半幅通靈，畫色間丹青。'
            ],
            "下載": []
        },
        {
            "key": 10,
            "曲目": "十",
            "詩名": "十蒸",
            "作者": "",
            "內容": [
                '新對舊，降對升，白犬對蒼鷹。葛巾對藜杖，澗水對池冰。',
                '張兔網，掛魚罾，燕雀對鶤鵬。爐中煎藥火，窗下讀書燈。',
                '織錦逐梭成舞鳳，畫屏誤筆作飛蠅。宴客劉公，座上滿斟三雅爵；',
                '迎仙漢帝，宮中高插九光燈。',
                '儒對士，佛對僧，面友對心朋。春殘對夏老，夜寢對晨興。',
                '千里馬，九霄鵬，霞蔚對雲蒸。寒堆陰嶺雪，春泮水池冰。',
                '亞父憤生撞玉斗，周公誓死作金縢。將軍元暉，莫怪人譏為餓虎；',
                '侍中盧昶，難逃世號作饑鷹。',
                '規對矩，墨對繩，獨步對同登。吟哦對諷詠，訪友對尋僧。',
                '風繞屋，水襄陵，紫鵠對蒼鷹。鳥寒驚夜月，魚暖上春冰。',
                '揚子口中飛白鳳，何郎鼻上集青蠅。巨鯉躍池，翻幾重之密藻；',
                '顛猿飲澗，掛百尺之垂藤。'
            ],
            "下載": []
        },
        {
            "key": 11,
            "曲目": "十一",
            "詩名": "十一尤",
            "作者": "",
            "內容": [
                '榮對辱，喜對憂，夜宴對日遊。燕關對楚水，蜀犬對吳牛。',
                '茶敵睡，酒消愁，青眼對白頭。馬遷修史記，孔子作春秋。',
                '適興子猷常泛棹，思歸王粲強登樓。窗下佳人，妝罷重將金插鬢；',
                '筵前舞妓，曲終還要錦纏頭。',
                '唇對齒，角對頭，策馬對騎牛。毫尖對筆底，綺閣對雕樓。',
                '楊柳岸，荻蘆洲，語燕對啼鳩。客乘金絡馬，人泛木蘭舟。',
                '綠野耕夫春舉耜，碧池漁父晚垂鉤。波浪千層，喜見蛟龍行水；',
                '雲霄萬里，驚看鵰鶚橫秋。',
                '庵對寺，殿對樓，酒艇對漁舟。金龍對彩鳳，豶豕對童牛。',
                '王郎帽，蘇子裘，四季對三秋。峰巒扶地秀，江漢接天流。',
                '一灣綠水漁村小，萬里青山佛寺幽。龍馬呈河，羲皇闡微而畫卦；',
                '神龜出洛，禹王取法以陳疇。'
            ],
            "下載": []
        },
        {
            "key": 12,
            "曲目": "十二",
            "詩名": "十二侵",
            "作者": "",
            "內容": [
                '眉對目，口對心，錦瑟對瑤琴。曉耕對寒釣，晚笛對秋砧。',
                '松鬱鬱，竹森森，閔損對曾參。秦王親擊缶，虞帝自揮琴。',
                '三獻卞和嘗泣玉，四知楊震固辭金。寂寂秋朝，庭葉因霜摧嫩色；',
                '沉沉春夜，砌花隨月轉清陰。',
                '前對後，古對今，野獸對山禽。犍牛對牝馬，水淺對山深。',
                '曾點瑟，戴逵琴，璞玉對渾金。艷紅花弄色，濃綠柳敷陰。',
                '不雨湯王方剪爪，有風楚子正披襟。書生惜壯歲韶華，寸陰尺璧；',
                '遊子愛良宵光景，一刻千金。',
                '絲對竹，劍對琴，素志對丹心。千愁對一醉，虎嘯對龍吟。',
                '子罕玉，不疑金，往古對來今。天寒鄒吹律，歲旱傅為霖。',
                '渠說子規為帝魄，儂知孔雀是家禽。屈子沉江，處處舟中爭繫粽；',
                '牛郎渡渚，家家臺上競穿針。'
            ],
            "下載": []
        },
        {
            "key": 13,
            "曲目": "十三",
            "詩名": "十三覃",
            "作者": "",
            "內容": [
                '千對百，兩對三，地北對天南。佛堂對仙洞，道院對禪庵。',
                '山潑黛，水浮藍，雪嶺對雲潭。鳳飛方翽翽，虎視已眈眈。',
                '窗下書生時諷詠，筵前酒客日醺酣。白草滿郊，秋日牧征人之馬；',
                '綠桑盈畝，春時供農婦之蠶。',
                '將對欲，可對堪，德被對恩覃。權衡對尺度，雪寺對雲庵。',
                '安邑棗，洞庭柑，不愧對無慚。魏徵能直諫，王衍善清談。',
                '紫梨摘去從山北，丹荔傳來自海南。攘雞非君子所為，但當月一；',
                '養狙是山公之智，止用朝三。',
                '中對外，北對南，貝母對宜男。修池對浚井，諫苦對言甘。',
                '千取百，二為三，魏尚對周堪。海門翻夕浪，山市擁晴嵐。',
                '新締直投公子紵，舊交猶脫館人驂。文達淹通，已詠冰兮寒過水；',
                '永和博雅，可知青者勝於藍。'
            ],
            "下載": []
        },
        {
            "key": 14,
            "曲目": "十四",
            "詩名": "十四鹽",
            "作者": "",
            "內容": [
                '悲對樂，愛對嫌，玉兔對銀蟾。醉侯對詩史，眼底對眉尖。',
                '風飁飁，雨綿綿，李苦對瓜甜。畫堂施錦帳，酒市舞青簾。',
                '橫槊賦詩傳孟德，引壺酌酒尚陶潛。兩曜迭明，日東生而月西出；',
                '五行式序，水下潤而火上炎。',
                '如對似，減對添，繡幕對珠簾。探珠對獻玉，鷺立對魚潛。',
                '玉屑飯，水晶鹽，手劍對腰鐮。燕巢依邃閣，蛛網掛虛檐。',
                '奪槊至三唐敬德，弈棋第一晉王恬。南浦客歸，湛湛春波千頃淨；',
                '西樓人悄，彎彎夜月一鉤纖。',
                '逢對遇，仰對瞻，市井對閭閻。投簪對結綬，握髮對掀髯。',
                '張繡幕，捲珠簾，石碏對江淹。宵征方肅肅，夜飲已厭厭。',
                '心褊小人長戚戚，禮多君子屢謙謙。美刺殊文，備三百五篇詩詠；',
                '吉凶異畫，變六十四卦爻占。'
            ],
            "下載": []
        },
        {
            "key": 15,
            "曲目": "十五",
            "詩名": "十五咸",
            "作者": "",
            "內容": [
                '清對濁，苦對鹹，一啟對三緘。煙蓑對雨笠，月榜對風帆。',
                '鶯睍睆，燕呢喃，柳杞對松杉。清涼悲素扇，淚痛濕青衫。',
                '漢室既能分四姓，周朝何用叛三監。破的而探牛心，豪矜王濟；',
                '豎竿以掛犢鼻，貧笑阮咸。',
                '能對否，聖對賢，衛瓘對渾瑊。雀羅對魚網，翠巘對蒼巖。',
                '紅羅帳，白布衫，筆架對書函。蕊香蜂競採，泥軟燕爭啣。',
                '凶孽誓清聞祖逖，王家能乂有巫咸。溪叟新居，漁舍清幽臨水岸；',
                '山僧久隱，梵宮寂寞倚雲岩。',
                '冠對帶，帽對衫，議鯁對言讒。行舟對御馬，俗弊對民岩。',
                '鼠且碩，兔多毚，史冊對書緘。',
                '塞城聞奏角，江浦認歸帆。',
                '河水一源形瀰瀰，泰山萬仞勢岩岩。鄭為武公，賦緇衣而美德；',
                '周因巷伯，歌貝錦以傷讒。'
                
            ],
            "下載": []
        },
    ]

}
export {
    Poems1,
    Poems2,
    Poems3,
    Poems4
}